// Generated from local PEŁNA_INSTRUKCJA sources. Do not edit by hand.
import type { ChapterContent, ContentBlock } from '../../types';
import { consolidateAddonChapters } from './consolidateAddonChapters';

export type PerfectRulebook = {
  chapters: ChapterContent[];
  firstGame: ContentBlock[];
  quickReference: ContentBlock[];
  mistakes: ContentBlock[];
  faq: ContentBlock[];
  glossary: ContentBlock[];
  examples: ContentBlock[];
  components: ContentBlock[];
  scoring: ContentBlock[];
};

const rawPerfectRulebooks: Record<string, PerfectRulebook> = {
  "spirit-island": {
    "chapters": [
      {
        "title": "Gra podstawowa + Zarośla i Szpony + Rozdarta Ziemia + Pióra i Płomienie",
        "content": [
          {
            "type": "heading",
            "text": "Pełny autorski szkic instrukcji cyfrowej",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "> Status: kompletna instrukcja systemu i dodatków na poziomie zasad ogólnych. Teksty indywidualnych Duchów, Mocy, Przeciwników, Scenariuszy i Wydarzeń należy katalogować na podstawie posiadanych komponentów. Nie wolno nadawać im statusu ready, dopóki katalog nie zostanie zweryfikowany."
          }
        ],
        "requiredAddons": [
          "branch-and-claw"
        ]
      },
      {
        "title": "1. O czym jest gra",
        "content": [
          {
            "type": "paragraph",
            "text": "Gracze wcielają się w Duchy wyspy broniące swojego domu przed Najeźdźcami. Duchy rozwijają swoją Obecność, zagrywają Moce, współdziałają z Dahanami i próbują wywołać wystarczająco dużo Strachu, aby wypędzić kolonizatorów."
          },
          {
            "type": "paragraph",
            "text": "Gra jest kooperacyjna. Wszyscy gracze zwyciężają albo przegrywają razem."
          }
        ]
      },
      {
        "title": "2. Warunki zwycięstwa",
        "content": [
          {
            "type": "paragraph",
            "text": "Na początku zwycięstwo wymaga usunięcia z wyspy wszystkich Odkrywców, Osad i Miast. Zdobywanie Strachu przesuwa grę na wyższe Poziomy Terroru, które łagodzą warunek zwycięstwa:"
          },
          {
            "type": "step-list",
            "steps": [
              "Terror I: na wyspie nie może być żadnego Najeźdźcy;",
              "Terror II: nie może być Osad ani Miast;",
              "Terror III: nie może być Miast;",
              "Terror IV: natychmiastowe zwycięstwo."
            ]
          },
          {
            "type": "paragraph",
            "text": "Zawsze najpierw rozpatrz bieżącą akcję lub efekt w całości, a następnie sprawdź zwycięstwo, chyba że dana karta mówi inaczej."
          }
        ]
      },
      {
        "title": "3. Warunki porażki",
        "content": [
          {
            "type": "paragraph",
            "text": "Wyspa przegrywa natychmiast, gdy:"
          },
          {
            "type": "step-list",
            "steps": [
              "trzeba dodać Zarazę, ale w puli nie ma znacznika;",
              "dowolny Duch traci całą Obecność z wyspy;",
              "zabraknie kart Najeźdźców, gdy należy dobrać kolejną;",
              "aktywny Scenariusz, Przeciwnik lub karta Wyspy Spustoszonej wprowadza własny warunek porażki."
            ]
          }
        ]
      },
      {
        "title": "4. Najważniejsze elementy",
        "content": [
          {
            "type": "step-list",
            "steps": [
              "plansze wyspy, podzielone na krainy i ocean;",
              "plansze Duchów z torami Obecności;",
              "znaczniki Obecności;",
              "karty Mocy unikalnych, mniejszych i większych;",
              "Odkrywcy, Osady i Miasta;",
              "Dahanie;",
              "Zaraza;",
              "talia Najeźdźców;",
              "talia Strachu;",
              "karta Wyspy Zdrowej/Spustoszonej;",
              "w dodatkach: Wydarzenia, Bestie, Dzicz, Choroba, Konflikt, Zła Ziemia i inne komponenty modułów."
            ]
          }
        ]
      },
      {
        "title": "5. Przygotowanie podstawowe",
        "content": [
          {
            "type": "checklist",
            "id": "setup-checklist",
            "title": "Kontrola przygotowania",
            "items": [
              "Przeczytaj kolejność przygotowania przed wyjęciem komponentów.",
              "Wykonaj kroki po kolei i sprawdź konfigurację graczy."
            ]
          },
          {
            "type": "step-list",
            "steps": [
              "Wybierz liczbę plansz wyspy równą liczbie graczy i połącz je zgodnie z wybranym układem.",
              "Umieść Najeźdźców i Dahan według ikon wydrukowanych na planszach.",
              "Przygotuj tor Najeźdźców: Odwet, Budowa i Eksploracja.",
              "Zbuduj talię Najeźdźców z kart etapów I, II i III zgodnie z wymaganym składem.",
              "Przygotuj talię Strachu, rozdzielając ją kartami Poziomu Terroru.",
              "Umieść kartę Wyspy Zdrowej właściwą dla liczby graczy i pulę Zarazy. Stosuj aktualną korektę: do puli dodaje się o 1 Zarazę więcej niż wynikałoby z samego mnożnika liczby graczy.",
              "Każdy wybiera Ducha, bierze planszę, karty unikalnych Mocy i znaczniki Obecności.",
              "Wykonaj indywidualne przygotowanie Ducha.",
              "Dla pierwszej gry nie używaj Przeciwnika ani Scenariusza. Użyj Duchów o niskiej złożoności.",
              "Przy dodatkach przygotuj tokeny, talię Wydarzeń i pozostałe elementy zgodnie z aktywnymi modułami."
            ]
          }
        ]
      },
      {
        "title": "6. Struktura rundy",
        "content": [
          {
            "type": "paragraph",
            "text": "Każda runda przebiega w tej kolejności:"
          },
          {
            "type": "heading",
            "text": "A. Faza Duchów",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Każdy Duch:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybiera jedną opcję Wzrostu;",
              "otrzymuje Energię wskazaną przez odsłonięte pole toru Energii;",
              "wybiera karty Mocy do zagrania i płaci ich koszt."
            ]
          },
          {
            "type": "paragraph",
            "text": "Gracze mogą wykonywać swoje czynności równocześnie, ale wszystkie wybory muszą być legalne."
          },
          {
            "type": "heading",
            "text": "B. Faza Szybkich Mocy",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Gracze rozpatrują zagrane Moce oznaczone jako szybkie, w dowolnie ustalonej kolejności."
          },
          {
            "type": "heading",
            "text": "C. Faza Najeźdźców",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "W zależności od użytych dodatków i stanu gry:"
          },
          {
            "type": "step-list",
            "steps": [
              "sprawdź kartę Wyspy Spustoszonej;",
              "od drugiej rundy rozpatrz Wydarzenie;",
              "rozpatrz zdobyte karty Strachu;",
              "Odwet;",
              "Budowa;",
              "Eksploracja;",
              "przesuń karty Najeźdźców w lewo."
            ]
          },
          {
            "type": "heading",
            "text": "D. Faza Wolnych Mocy",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Rozpatrz zagrane wolne Moce."
          },
          {
            "type": "heading",
            "text": "E. Upływ Czasu",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "odrzuć wszystkie zagrane w tej rundzie karty Mocy;",
              "usuń znaczniki jednorundowych efektów;",
              "odwróć lub przywróć elementy zgodnie z ich zasadami;",
              "przejdź do kolejnej rundy."
            ]
          }
        ]
      },
      {
        "title": "7. Wzrost i Obecność",
        "content": [
          {
            "type": "paragraph",
            "text": "Wzrost reprezentuje rozwój Ducha. Opcje mogą pozwalać m.in.:"
          },
          {
            "type": "step-list",
            "steps": [
              "dodać Obecność;",
              "dobrać kartę Mocy;",
              "odzyskać zagrane karty;",
              "zyskać Energię;",
              "przesunąć Obecność;",
              "wykonać specjalną czynność."
            ]
          },
          {
            "type": "paragraph",
            "text": "Dodając Obecność:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz znacznik z toru na planszy Ducha;",
              "umieść go w legalnej krainie w podanym zasięgu;",
              "odkryte pole toru od tej chwili zmienia dochód Energii, liczbę zagrywanych kart albo daje efekt specjalny."
            ]
          },
          {
            "type": "paragraph",
            "text": "Obecność może współdzielić krainę z innymi elementami. Sama Obecność nie blokuje Najeźdźców ani nie zadaje obrażeń."
          },
          {
            "type": "paragraph",
            "text": "Święte Miejsce to kraina z co najmniej 2 Obecnościami tego samego Ducha, chyba że plansza Ducha zmienia tę definicję."
          }
        ]
      },
      {
        "title": "8. Karty Mocy",
        "content": [
          {
            "type": "paragraph",
            "text": "Każda karta określa:"
          },
          {
            "type": "step-list",
            "steps": [
              "szybkość;",
              "koszt Energii;",
              "zasięg;",
              "legalny cel;",
              "efekt;",
              "elementy;",
              "czasem progi elementów."
            ]
          },
          {
            "type": "heading",
            "text": "Zagrywanie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "W Fazie Duchów wybierz maksymalnie tyle kart, ile pozwala odsłonięty tor zagrywanych kart. Zapłać łączny koszt Energii."
          },
          {
            "type": "heading",
            "text": "Rozpatrywanie",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "Sprawdź zasięg z jednej z własnych Obecności.",
              "Sprawdź wymagania celu.",
              "Wybierz jeden legalny cel.",
              "Wykonaj instrukcje karty od góry do dołu.",
              "Zastosuj progi elementów, jeśli posiadasz wymagane elementy."
            ]
          },
          {
            "type": "paragraph",
            "text": "Elementy nie są zużywane. Ta sama ikona może spełnić wymagania wielu Mocy i progów w tej samej rundzie."
          },
          {
            "type": "paragraph",
            "text": "Nie wolno zmienić celu po rozpoczęciu rozpatrywania, chyba że efekt wyraźnie na to pozwala."
          }
        ]
      },
      {
        "title": "9. Zasięg i celowanie",
        "content": [
          {
            "type": "paragraph",
            "text": "Zasięg liczysz pomiędzy krainami po sąsiedztwie. Kraina z Obecnością ma zasięg 0. Ocean nie jest zwykłą krainą, chyba że aktywny Duch lub efekt traktuje go inaczej."
          },
          {
            "type": "paragraph",
            "text": "Ograniczenia celu mogą wymagać:"
          },
          {
            "type": "step-list",
            "steps": [
              "konkretnego rodzaju terenu;",
              "obecności albo braku Najeźdźców;",
              "Dahan;",
              "własnej Obecności;",
              "Świętego Miejsca;",
              "krainy przybrzeżnej lub śródlądowej."
            ]
          },
          {
            "type": "paragraph",
            "text": "Jeśli nie ma legalnego celu, Mocy nie można rozpatrzyć. Zagraną kartę nadal uważa się za zagraną."
          }
        ]
      },
      {
        "title": "10. Najeźdźcy",
        "content": [
          {
            "type": "paragraph",
            "text": "Najeźdźcy występują jako:"
          },
          {
            "type": "step-list",
            "steps": [
              "Odkrywca: 1 Zdrowia, 1 obrażenie;",
              "Osada: 2 Zdrowia, 2 obrażenia;",
              "Miasto: 3 Zdrowia, 3 obrażenia."
            ]
          },
          {
            "type": "paragraph",
            "text": "Zniszczenie Osady generuje 1 Strach, a Miasta 2 Strachu. Samo zadanie obrażeń bez zniszczenia nie generuje Strachu."
          },
          {
            "type": "paragraph",
            "text": "Obrażenia Najeźdźców utrzymują się tylko do końca bieżącej akcji. Jeśli element nie został zniszczony, po zakończeniu akcji wraca do pełnego Zdrowia."
          }
        ]
      },
      {
        "title": "11. Odwet",
        "content": [
          {
            "type": "paragraph",
            "text": "Dla każdej krainy typu wskazanego na karcie Odwetu:"
          },
          {
            "type": "step-list",
            "steps": [
              "zsumuj obrażenia wszystkich Najeźdźców;",
              "odejmij Obronę działającą w tej krainie;",
              "pozostałe obrażenia zostają zadane jednocześnie krainie i Dahanom."
            ]
          },
          {
            "type": "heading",
            "text": "Obrażenia krainy",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Jeśli po Obronie kraina otrzymuje co najmniej 2 obrażenia, dodaj do niej 1 Zarazę. Nie dodawaj większej liczby Zarazy tylko dlatego, że obrażeń było więcej."
          },
          {
            "type": "heading",
            "text": "Obrażenia Dahan",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Każdy Dahan ma 2 Zdrowia. Rozdziel obrażenia pomiędzy Dahan w dozwolony sposób. Zniszczone figurki usuń."
          },
          {
            "type": "heading",
            "text": "Kontratak",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Jeśli po obrażeniach pozostał co najmniej jeden Dahan, każdy ocalały Dahan zadaje 2 obrażenia Najeźdźcom. Gracze wspólnie rozdzielają te obrażenia."
          },
          {
            "type": "paragraph",
            "text": "Przykład: w krainie są Osada i Odkrywca, czyli łącznie 3 obrażenia. Obrona 2 zmniejsza je do 1. Kraina nie otrzymuje Zarazy, a obecny Dahan otrzymuje 1 obrażenie i następnie kontratakuje za 2."
          }
        ]
      },
      {
        "title": "12. Budowa",
        "content": [
          {
            "type": "paragraph",
            "text": "W każdej wskazanej krainie zawierającej Najeźdźców:"
          },
          {
            "type": "step-list",
            "steps": [
              "jeśli jest więcej Miast niż Osad, dodaj Miasto;",
              "w przeciwnym razie dodaj Osadę."
            ]
          },
          {
            "type": "paragraph",
            "text": "Choroba może zapobiec jednej Budowie w krainie, po czym jest usuwana. Efekty Przeciwników mogą zmieniać tę procedurę."
          }
        ]
      },
      {
        "title": "13. Eksploracja",
        "content": [
          {
            "type": "paragraph",
            "text": "Dla każdej wskazanej krainy dodaj Odkrywcę, jeśli kraina ma źródło Najeźdźców:"
          },
          {
            "type": "step-list",
            "steps": [
              "sąsiaduje z oceanem;",
              "sąsiaduje z krainą zawierającą Osadę lub Miasto;",
              "spełnia dodatkową regułę aktywnego Przeciwnika."
            ]
          },
          {
            "type": "paragraph",
            "text": "Dzicz zapobiega jednej Eksploracji w krainie i jest następnie usuwana."
          }
        ]
      },
      {
        "title": "14. Strach",
        "content": [
          {
            "type": "paragraph",
            "text": "Za każdym razem, gdy generujesz Strach, przesuń znaczniki z puli Strachu do puli wygenerowanego Strachu. Gdy wygenerujesz liczbę Strachu równą progowi zależnemu od liczby graczy:"
          },
          {
            "type": "step-list",
            "steps": [
              "zdobądź wierzchnią kartę Strachu;",
              "odłóż ją zakrytą do rozpatrzenia;",
              "zwróć znaczniki do puli Strachu;",
              "nadmiar Strachu przechodzi na kolejną kartę."
            ]
          },
          {
            "type": "paragraph",
            "text": "Gdy zostanie odsłonięta karta Terroru, od tej chwili obowiązuje łagodniejszy warunek zwycięstwa."
          }
        ]
      },
      {
        "title": "15. Zaraza",
        "content": [
          {
            "type": "paragraph",
            "text": "Gdy kraina otrzymuje Zarazę:"
          },
          {
            "type": "step-list",
            "steps": [
              "dodaj 1 znacznik z karty Wyspy;",
              "zniszcz po 1 Obecności każdego Ducha w tej krainie;",
              "jeśli kraina już miała Zarazę, następuje kaskada: wybierz jedną sąsiednią krainę i dodaj tam Zarazę; kaskada może się powtarzać."
            ]
          },
          {
            "type": "paragraph",
            "text": "Gdy pula Wyspy Zdrowej się wyczerpie:"
          },
          {
            "type": "step-list",
            "steps": [
              "odwróć kartę;",
              "wykonaj jej instrukcję;",
              "przygotuj nową pulę Zarazy po stronie Wyspy Spustoszonej."
            ]
          }
        ]
      },
      {
        "title": "16. Tokeny dodatków",
        "content": [
          {
            "type": "heading",
            "text": "Dzicz",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Pierwsza normalna Eksploracja w krainie zostaje pominięta. Usuń Dzicz."
          },
          {
            "type": "heading",
            "text": "Choroba",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Pierwsza normalna Budowa w krainie zostaje pominięta. Usuń Chorobę. Choroba nie usuwa istniejących budynków."
          },
          {
            "type": "heading",
            "text": "Konflikt",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Gdy wybrany Najeźdźca miałby zadać obrażenia podczas Odwetu, możesz usunąć Konflikt spod niego, aby anulować jego obrażenia w tej akcji."
          },
          {
            "type": "heading",
            "text": "Bestie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Nie mają wrodzonego efektu. Są wykorzystywane przez Moce, Wydarzenia i karty Strachu."
          },
          {
            "type": "heading",
            "text": "Zła Ziemia",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Zwiększa obrażenia zadawane przez pojedynczą akcję Najeźdźcom i Dahanom w krainie. Nie zwiększa obrażeń zadawanych samej krainie."
          },
          {
            "type": "heading",
            "text": "Izolacja",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Modyfikuje sąsiedztwo i źródła Najeźdźców zgodnie z zasadami efektu. Zwykle nie blokuje przemieszczania Dahan ani używania zasięgu przez Duchy. Dokładne konsekwencje należy opisać w osobnej sekcji timingowej."
          }
        ]
      },
      {
        "title": "17. Wydarzenia",
        "content": [
          {
            "type": "paragraph",
            "text": "Wydarzenia wprowadzają nieprzewidywalność. Nie rozpatruj Wydarzenia w pierwszej rundzie. Od drugiej rundy:"
          },
          {
            "type": "step-list",
            "steps": [
              "dobierz kartę;",
              "rozpatrz sekcje w podanej kolejności;",
              "jeśli jest wybór zespołowy, gracze wspólnie wybierają opcję i opłacają koszt zgodnie z kartą;",
              "wykonaj sekcje Bestii i Dahan."
            ]
          },
          {
            "type": "paragraph",
            "text": "Tekst Wydarzenia może zmienić reguły ogólne na czas jego rozpatrywania."
          }
        ],
        "requiredAddons": [
          "branch-and-claw"
        ]
      },
      {
        "title": "18. Przeciwnicy i Scenariusze",
        "content": [
          {
            "type": "paragraph",
            "text": "Przeciwnik zmienia przygotowanie i zachowanie Najeźdźców. Poziomy kumulują się: grając na poziomie 4, stosujesz także poziomy 1–3, chyba że karta mówi inaczej."
          },
          {
            "type": "paragraph",
            "text": "Scenariusz wprowadza własny cel, setup lub strukturę gry. Nie łącz modułów bez sprawdzenia kompatybilności."
          },
          {
            "type": "paragraph",
            "text": "W aplikacji każdy poziom Przeciwnika i Scenariusz musi mieć osobny, zweryfikowany wpis. [DO WERYFIKACJI: katalog kart]."
          }
        ]
      },
      {
        "title": "19. Zawartość dodatków",
        "content": [
          {
            "type": "heading",
            "text": "Zarośla i Szpony",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Dodaje Wydarzenia oraz tokeny Bestii, Dziczy, Choroby i Konfliktu, a także nowych Duchów, Moce i Przeciwnika."
          },
          {
            "type": "heading",
            "text": "Rozdarta Ziemia",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Rozbudowuje system tokenów, wprowadza Złą Ziemię i Izolację, nowych Duchów o szerokim zakresie złożoności, nowe plansze, Moce, Wydarzenia, Scenariusze i Przeciwników."
          },
          {
            "type": "heading",
            "text": "Pióra i Płomienie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Zbiera dodatkowe Duchy i zawartość promocyjną. Każdy Duch ma własne przygotowanie i regułę specjalną, które mają pierwszeństwo przed zasadami ogólnymi."
          }
        ]
      },
      {
        "title": "20. Koniec rundy i zwycięstwo",
        "content": [
          {
            "type": "paragraph",
            "text": "Po Fazie Wolnych Mocy sprawdź warunki zwycięstwa i porażki, usuń znaczniki czasowe, odrzuć zagrane karty i rozpocznij kolejną rundę."
          },
          {
            "type": "paragraph",
            "text": "Jeśli zwycięstwo i porażka wynikają z tego samego w pełni rozpatrzonego efektu, zastosuj oficjalne reguły kolejności dla danej sytuacji i wpis FAQ. [DO WERYFIKACJI: edge cases aktualnego FAQ]."
          }
        ]
      }
    ],
    "firstGame": [
      {
        "type": "step-list",
        "steps": [
          "Wybierz Duchy o niskiej złożoności.",
          "Nie używaj Przeciwnika, Scenariusza ani Wydarzeń.",
          "Rozłóż jedną planszę na gracza.",
          "W pierwszej Fazie Duchów przeczytaj wszystkie opcje Wzrostu na głos.",
          "Najpierw zaplanuj Szybkie Moce, które zapobiegną Budowie lub Odwetowi.",
          "Wolne Moce traktuj jako przygotowanie następnej rundy.",
          "Przed Fazą Najeźdźców wskaż wszystkie krainy Odwetu, Budowy i Eksploracji.",
          "Po pierwszej rundzie dodaj Wydarzenia dopiero w kolejnej partii."
        ]
      }
    ],
    "quickReference": [
      {
        "type": "step-list",
        "steps": [
          "Wzrost.",
          "Energia.",
          "Zagrywanie i opłacanie kart.",
          "Szybkie Moce.",
          "Wydarzenie od rundy 2.",
          "Strach.",
          "Odwet.",
          "Budowa.",
          "Eksploracja.",
          "Przesunięcie kart.",
          "Wolne Moce.",
          "Upływ Czasu."
        ]
      }
    ],
    "mistakes": [
      {
        "type": "step-list",
        "steps": [
          "Zużywanie elementów po sprawdzeniu progu.",
          "Dodawanie wielu Zaraz za jeden bardzo silny Odwet.",
          "Pozostawianie obrażeń na Najeźdźcach między akcjami.",
          "Kontratak Dahan przed obrażeniami.",
          "Traktowanie Bestii jak jednostek walczących bez efektu karty.",
          "Eksploracja z sąsiedniego Odkrywcy. Źródłem jest Osada, Miasto lub ocean, nie sam Odkrywca.",
          "Rozpatrywanie Wydarzenia w pierwszej rundzie.",
          "Zapominanie o dodatkowej Zarazie z aktualnej korekty setupu.",
          "Liczenie Obecności innych Duchów jako własnego Świętego Miejsca."
        ]
      }
    ],
    "faq": [
      {
        "type": "paragraph",
        "text": "Czy można zagrywać szybkie i wolne Moce w dowolnej kolejności? Tylko wewnątrz odpowiedniej fazy. Wszystkie szybkie rozpatruje się przed Fazą Najeźdźców, a wolne po niej."
      },
      {
        "type": "paragraph",
        "text": "Czy elementy się wydaje? Nie. Elementy są symbolami posiadanymi w danej rundzie."
      },
      {
        "type": "paragraph",
        "text": "Czy jedna karta może spełnić kilka progów? Tak, o ile posiadasz wymagane elementy."
      },
      {
        "type": "paragraph",
        "text": "Czy Ochrona broni Dahan i krainy? Tak. Ta sama wartość redukuje łączny pakiet obrażeń Najeźdźców przed zadaniem go krainie i Dahanom."
      },
      {
        "type": "paragraph",
        "text": "Czy Ochrona działa na obrażenia z Mocy lub Wydarzeń? Tylko jeśli efekt mówi, że są to obrażenia Najeźdźców podczas Odwetu albo wyraźnie rozszerza działanie."
      },
      {
        "type": "paragraph",
        "text": "Czy przesunięcie Najeźdźcy niszczy go? Nie. Zmienia tylko jego krainę."
      },
      {
        "type": "paragraph",
        "text": "Czy Osada generuje Strach przy usunięciu bez „zniszczenia”? Zależy od użytego czasownika efektu. Katalog terminów musi rozróżniać „zniszcz”, „usuń” i „zastąp”."
      },
      {
        "type": "paragraph",
        "text": "Czy można wybrać cel bez efektu? Tak tylko wtedy, gdy cel jest legalny. Nie wolno łamać warunków celu."
      },
      {
        "type": "paragraph",
        "text": "Czy Zaraza niszczy wszystkie Obecności? Niszczy po jednej Obecności każdego Ducha w tej krainie, o ile efekt nie zmienia zasady."
      },
      {
        "type": "paragraph",
        "text": "Czy Dzicz blokuje Eksplorację wywołaną kartą Mocy? Nie automatycznie. Blokuje normalną akcję Eksploracji Najeźdźców, chyba że efekt mówi inaczej."
      }
    ],
    "glossary": [
      {
        "type": "step-list",
        "steps": [
          "Dahan — rdzenni mieszkańcy wyspy; kontratakują po przetrwaniu Odwetu.",
          "Element — symbol na karcie lub torze, używany do spełniania progów.",
          "Obecność — znacznik Ducha na wyspie, źródło zasięgu.",
          "Święte Miejsce — zwykle kraina z co najmniej 2 Obecnościami jednego Ducha.",
          "Odwet — akcja Najeźdźców zadająca obrażenia krainie i Dahanom.",
          "Budowa — akcja dodająca Osadę albo Miasto.",
          "Eksploracja — akcja dodająca Odkrywcę do krainy ze źródłem.",
          "Strach — postęp prowadzący do kart Strachu i wyższych poziomów Terroru.",
          "Zaraza — trwałe uszkodzenie wyspy.",
          "Zasięg 0 — cel w krainie zawierającej źródłową Obecność."
        ]
      }
    ],
    "examples": [],
    "components": [
      {
        "type": "step-list",
        "steps": [
          "plansze wyspy, podzielone na krainy i ocean;",
          "plansze Duchów z torami Obecności;",
          "znaczniki Obecności;",
          "karty Mocy unikalnych, mniejszych i większych;",
          "Odkrywcy, Osady i Miasta;",
          "Dahanie;",
          "Zaraza;",
          "talia Najeźdźców;",
          "talia Strachu;",
          "karta Wyspy Zdrowej/Spustoszonej;",
          "w dodatkach: Wydarzenia, Bestie, Dzicz, Choroba, Konflikt, Zła Ziemia i inne komponenty modułów."
        ]
      }
    ],
    "scoring": [
      {
        "type": "paragraph",
        "text": "Na początku zwycięstwo wymaga usunięcia z wyspy wszystkich Odkrywców, Osad i Miast. Zdobywanie Strachu przesuwa grę na wyższe Poziomy Terroru, które łagodzą warunek zwycięstwa:"
      },
      {
        "type": "step-list",
        "steps": [
          "Terror I: na wyspie nie może być żadnego Najeźdźcy;",
          "Terror II: nie może być Osad ani Miast;",
          "Terror III: nie może być Miast;",
          "Terror IV: natychmiastowe zwycięstwo."
        ]
      },
      {
        "type": "paragraph",
        "text": "Zawsze najpierw rozpatrz bieżącą akcję lub efekt w całości, a następnie sprawdź zwycięstwo, chyba że dana karta mówi inaczej."
      },
      {
        "type": "paragraph",
        "text": "Wyspa przegrywa natychmiast, gdy:"
      },
      {
        "type": "step-list",
        "steps": [
          "trzeba dodać Zarazę, ale w puli nie ma znacznika;",
          "dowolny Duch traci całą Obecność z wyspy;",
          "zabraknie kart Najeźdźców, gdy należy dobrać kolejną;",
          "aktywny Scenariusz, Przeciwnik lub karta Wyspy Spustoszonej wprowadza własny warunek porażki."
        ]
      }
    ]
  },
  "projekt-gaja": {
    "chapters": [
      {
        "title": "1. Cel gry",
        "content": [
          {
            "type": "paragraph",
            "text": "Przez 6 rund rozwijasz międzygwiezdną cywilizację. Kolonizujesz planety, ulepszasz budynki, rozwijasz technologie, tworzysz federacje i wykonujesz Projekty Gaja. Zdobywasz punkty w trakcie gry, za cele rund oraz na końcu za cele końcowe, pozycje na torach badań i pozostałe zasoby."
          },
          {
            "type": "paragraph",
            "text": "Wygrywa gracz z największą liczbą punktów. Remisy rozstrzyga się według oficjalnej kolejności zapisanej w sekcji punktowania i katalogu wariantu. [DO WERYFIKACJI: dokładna reguła remisu właściwego wydania]."
          }
        ]
      },
      {
        "title": "2. Najważniejsze elementy",
        "content": [
          {
            "type": "step-list",
            "steps": [
              "modułowa mapa kosmosu;",
              "planety w różnych kolorach;",
              "plansze frakcji;",
              "kopalnie, stacje handlowe, laboratoria, akademie i instytut planetarny;",
              "zasoby: kredyty, ruda, wiedza i Q.I.C.;",
              "znaczniki mocy w trzech misach;",
              "tory badań;",
              "technologie standardowe i zaawansowane;",
              "kafle federacji;",
              "boostery rund;",
              "cele rund i cele końcowe;",
              "Gaiaformery i planety Transdim;",
              "w Zaginionej Flocie: sektory głębokiej przestrzeni, statki, plansze eksploracji, artefakty, nowe technologie, boostery, punktowanie i cztery frakcje."
            ]
          }
        ]
      },
      {
        "title": "3. Przygotowanie",
        "content": [
          {
            "type": "checklist",
            "id": "setup-checklist",
            "title": "Kontrola przygotowania",
            "items": [
              "Przeczytaj kolejność przygotowania przed wyjęciem komponentów.",
              "Wykonaj kroki po kolei i sprawdź konfigurację graczy."
            ]
          },
          {
            "type": "step-list",
            "steps": [
              "Zbuduj mapę odpowiednią dla liczby graczy. W podstawowej grze użyj wskazanego układu sektorów.",
              "Rozłóż planszę badań, technologie i płytki zaawansowane.",
              "Wylosuj cele rund i cele końcowe.",
              "Rozłóż boostery w liczbie wymaganej dla graczy.",
              "Gracze wybierają frakcje i przygotowują plansze.",
              "Umieść początkowe budynki zgodnie z kolejnością setupu frakcji.",
              "Wybierz boostery startowe w odwrotnej kolejności.",
              "Przygotuj zasoby i znaczniki mocy według plansz frakcji.",
              "Przy Zaginionej Flocie zastosuj nowy sposób przygotowania mapy, plansze statków i eksploracji oraz elementy zastępujące podstawowe akcje Q.I.C. Dokładna liczba elementów zależy od liczby graczy i wybranego układu."
            ]
          }
        ]
      },
      {
        "title": "4. Struktura rundy",
        "content": [
          {
            "type": "paragraph",
            "text": "Każda z 6 rund składa się z:"
          },
          {
            "type": "heading",
            "text": "A. Faza dochodu",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Wszyscy otrzymują zasoby wskazane przez odsłonięte ikony dochodu:"
          },
          {
            "type": "step-list",
            "steps": [
              "na planszy frakcji;",
              "na technologiach;",
              "na boosterze;",
              "z innych aktywnych elementów."
            ]
          },
          {
            "type": "paragraph",
            "text": "Dochód mocy oznacza ładowanie znaczników przez misy, a nie pobieranie nowych znaczników z puli."
          },
          {
            "type": "heading",
            "text": "B. Faza Gai",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "zakończ aktywne Projekty Gaja;",
              "przekształć odpowiednie planety Transdim w planety Gaja;",
              "przenieś znaczniki mocy z obszaru Gaja zgodnie z zasadami frakcji i toru;",
              "odzyskaj Gaiaformery, gdy zasada na to pozwala."
            ]
          },
          {
            "type": "heading",
            "text": "C. Faza akcji",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Gracze wykonują po jednej akcji zgodnie z ruchem wskazówek zegara. Gracz, który spasował, nie wykonuje już akcji w tej rundzie."
          },
          {
            "type": "heading",
            "text": "D. Koniec rundy",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "odwróć użyte akcje specjalne;",
              "usuń znaczniki z celów rundy, jeśli są jednorazowe;",
              "odzyskaj elementy wskazane przez reguły;",
              "przygotuj następny kafel celu rundy;",
              "kolejność nowej rundy wynika z kolejności pasowania."
            ]
          }
        ]
      },
      {
        "title": "5. Zasoby",
        "content": [
          {
            "type": "heading",
            "text": "Kredyty",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Najczęściej opłacają budynki, ulepszenia i inne koszty gospodarcze."
          },
          {
            "type": "heading",
            "text": "Ruda",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Służy głównie do budowy i terraforming."
          },
          {
            "type": "heading",
            "text": "Wiedza",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Pozwala awansować na torach badań."
          },
          {
            "type": "heading",
            "text": "Q.I.C.",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Rzadki zasób wykorzystywany m.in. do zwiększania zasięgu, niektórych akcji specjalnych i efektów technologii."
          },
          {
            "type": "paragraph",
            "text": "Zasobów nie można wydawać ponad stan. Limity na torach planszy frakcji są twarde; nadwyżka zazwyczaj przepada, chyba że efekt mówi inaczej."
          }
        ]
      },
      {
        "title": "6. Moc i trzy misy",
        "content": [
          {
            "type": "paragraph",
            "text": "Znaczniki mocy krążą przez trzy misy:"
          },
          {
            "type": "step-list",
            "steps": [
              "z misy I do II;",
              "z II do III;",
              "tylko znaczniki w misie III można standardowo wydawać."
            ]
          },
          {
            "type": "paragraph",
            "text": "Gdy otrzymujesz określoną ilość mocy, przesuwasz znaczniki krok po kroku. Najpierw wszystkie dostępne z misy I do II, potem z II do III."
          },
          {
            "type": "heading",
            "text": "Wydawanie mocy",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Przenieś wymaganą liczbę znaczników z misy III do misy I."
          },
          {
            "type": "heading",
            "text": "Palenie mocy",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Możesz na stałe usunąć znacznik z misy II, aby przesunąć drugi znacznik z misy II do III. To przyspiesza dostęp do mocy, ale zmniejsza całkowitą pulę."
          },
          {
            "type": "paragraph",
            "text": "Nie wolno palić znacznika, jeśli nie ma drugiego znacznika do przesunięcia."
          }
        ]
      },
      {
        "title": "7. Akcje główne",
        "content": [
          {
            "type": "paragraph",
            "text": "W swojej turze wykonaj jedną z akcji:"
          },
          {
            "type": "step-list",
            "steps": [
              "zbuduj kopalnię;",
              "rozpocznij Projekt Gaja;",
              "ulepsz budynek;",
              "utwórz federację;",
              "awansuj na torze badań;",
              "wykonaj akcję mocy lub Q.I.C.;",
              "wykonaj akcję specjalną;",
              "spasuj."
            ]
          },
          {
            "type": "paragraph",
            "text": "Efekty darmowe oznaczone jako „free action” można wykonywać przed, po i pomiędzy krokami akcji, jeśli nie przerywają nierozdzielnego efektu."
          }
        ]
      },
      {
        "title": "8. Budowa kopalni",
        "content": [
          {
            "type": "paragraph",
            "text": "Aby zbudować kopalnię:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz niezamieszkaną planetę w zasięgu;",
              "określ liczbę kroków terraforming dzielącą jej kolor od rodzimego koloru frakcji;",
              "opłać terraforming;",
              "opłać koszt kopalni;",
              "umieść najdalej wysuniętą w lewo kopalnię z planszy frakcji;",
              "zdobądź punkty celu rundy, technologii lub efektów, jeśli warunki są spełnione."
            ]
          },
          {
            "type": "paragraph",
            "text": "Planeta Gaja może być kolonizowana przez wszystkie frakcje według osobnego kosztu. Planeta Transdim nie może otrzymać zwykłej kopalni przed ukończeniem Projektu Gaja."
          }
        ]
      },
      {
        "title": "9. Zasięg",
        "content": [
          {
            "type": "paragraph",
            "text": "Zasięg liczysz jako najmniejszą liczbę połączeń między polami kosmosu. Podstawowy zasięg zależy od toru Nawigacji i zdolności frakcji."
          },
          {
            "type": "paragraph",
            "text": "Możesz zwiększyć zasięg:"
          },
          {
            "type": "step-list",
            "steps": [
              "wydając Q.I.C.;",
              "używając boostera lub technologii;",
              "korzystając ze zdolności frakcji."
            ]
          },
          {
            "type": "paragraph",
            "text": "W przykładach aplikacja powinna pokazywać mapę z odległością 1, 2, 3 i trasą niedozwoloną."
          }
        ]
      },
      {
        "title": "10. Terraforming",
        "content": [
          {
            "type": "paragraph",
            "text": "Koło kolorów na planszy frakcji pokazuje odległość pomiędzy rodzajem planety a planetą macierzystą. Każdy krok kosztuje rudę, a rozwój toru Terraformacji obniża koszt jednego kroku."
          },
          {
            "type": "paragraph",
            "text": "Nie wolno częściowo terraformować planety i pozostawić jej na później. Cały koszt i budowa kopalni stanowią jedną akcję."
          }
        ]
      },
      {
        "title": "11. Ulepszanie budynków",
        "content": [
          {
            "type": "paragraph",
            "text": "Standardowa ścieżka:"
          },
          {
            "type": "step-list",
            "steps": [
              "kopalnia → stacja handlowa;",
              "stacja handlowa → laboratorium albo instytut planetarny;",
              "laboratorium → akademia."
            ]
          },
          {
            "type": "paragraph",
            "text": "Ulepszając:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz własny budynek;",
              "sprawdź właściwy koszt;",
              "zastosuj niższy koszt stacji handlowej, jeśli spełniasz warunek sąsiedztwa;",
              "zwróć stary budynek na planszę frakcji;",
              "umieść nowy budynek;",
              "przy laboratorium lub akademii pobierz technologię, jeśli należy się w tym momencie."
            ]
          },
          {
            "type": "paragraph",
            "text": "Odsłonięcie i zakrycie pól zmienia przyszły dochód."
          }
        ]
      },
      {
        "title": "12. Sąsiedztwo i pasywne ładowanie mocy",
        "content": [
          {
            "type": "paragraph",
            "text": "Gdy gracz buduje lub ulepsza w sąsiedztwie innych graczy, sąsiedzi mogą otrzymać możliwość ładowania mocy. Liczba mocy zależy od wartości nowego budynku i układu mapy."
          },
          {
            "type": "paragraph",
            "text": "Gracz przyjmujący moc zwykle traci punkty w wysokości o 1 mniejszej niż liczba przyjętej mocy. Może przyjąć mniej albo odmówić. [DO WERYFIKACJI: tabela wartości budynków i dokładne wyjątki frakcji]."
          }
        ]
      },
      {
        "title": "13. Projekt Gaja",
        "content": [
          {
            "type": "paragraph",
            "text": "Aby przekształcić planetę Transdim:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz planetę w zasięgu;",
              "zapłać koszt uruchomienia zależny od poziomu toru Projektu Gaja;",
              "przenieś odpowiednią liczbę znaczników mocy do obszaru Gaja;",
              "umieść Gaiaformer na planecie."
            ]
          },
          {
            "type": "paragraph",
            "text": "W Fazie Gai następnej rundy planeta staje się planetą Gaja. Nadal trzeba wykonać później akcję budowy kopalni, zapłacić koszt i spełnić zasięg."
          },
          {
            "type": "paragraph",
            "text": "Gaiaformer oznacza rezerwację dla właściciela, ale dokładne interakcje frakcji i dodatku wymagają wpisów w FAQ."
          }
        ]
      },
      {
        "title": "14. Tory badań",
        "content": [
          {
            "type": "paragraph",
            "text": "Istnieje sześć dziedzin badań. Akcja badań albo zdobycie technologii pozwala przesunąć znacznik o jedno pole."
          },
          {
            "type": "step-list",
            "steps": [
              "nie można wejść na najwyższy poziom bez zielonego tokena federacji;",
              "na szczycie danego toru zwykle może znajdować się ograniczona liczba graczy;",
              "niektóre pola dają natychmiastowy bonus;",
              "tor badań zapewnia punkty na końcu gry."
            ]
          },
          {
            "type": "paragraph",
            "text": "Niektóre technologie zaawansowane wymagają przykrycia posiadanej technologii standardowej i odpowiedniego poziomu na powiązanym torze."
          }
        ]
      },
      {
        "title": "15. Technologie",
        "content": [
          {
            "type": "heading",
            "text": "Standardowe",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Dają efekt natychmiastowy, dochód, akcję specjalną albo punktowanie."
          },
          {
            "type": "heading",
            "text": "Zaawansowane",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Są silniejsze i wymagają:"
          },
          {
            "type": "step-list",
            "steps": [
              "odpowiedniej pozycji na torze;",
              "przykrycia technologii standardowej;",
              "spełnienia dodatkowych warunków."
            ]
          },
          {
            "type": "paragraph",
            "text": "W aplikacji każda technologia musi mieć osobny wpis z timingiem, aliasami ikon i przykładami. [DO WERYFIKACJI: katalog kafli]."
          }
        ]
      },
      {
        "title": "16. Federacje",
        "content": [
          {
            "type": "paragraph",
            "text": "Federacja to połączona sieć własnych struktur o wymaganej łącznej wartości mocy."
          },
          {
            "type": "paragraph",
            "text": "Aby ją utworzyć:"
          },
          {
            "type": "step-list",
            "steps": [
              "wskaż grupę własnych budynków;",
              "połącz je najmniejszą legalną liczbą satelitów;",
              "sprawdź wymaganą sumę wartości;",
              "wydaj po jednym znaczniku mocy za każdy satelita;",
              "wybierz dostępny token federacji;",
              "oznacz wszystkie użyte struktury jako należące do tej federacji."
            ]
          },
          {
            "type": "paragraph",
            "text": "Zwykle struktura nie może należeć do drugiej federacji, chyba że nowa federacja łączy istniejące federacje zgodnie z wyjątkami. Sieć musi być minimalna: nie dodawaj satelitów tylko po to, by sztucznie zwiększyć obszar."
          }
        ]
      },
      {
        "title": "17. Akcje mocy i Q.I.C.",
        "content": [
          {
            "type": "paragraph",
            "text": "Pola akcji są dostępne wspólnie. Po wykonaniu akcji zakryj ją znacznikiem, aby inni nie mogli jej użyć w tej rundzie."
          },
          {
            "type": "paragraph",
            "text": "W Zaginionej Flocie część podstawowych akcji Q.I.C. przenoszą statki i plansze eksploracji. Nie korzystaj jednocześnie ze starej i nowej lokalizacji tej samej akcji."
          }
        ]
      },
      {
        "title": "18. Pasowanie",
        "content": [
          {
            "type": "paragraph",
            "text": "Gdy pasujesz:"
          },
          {
            "type": "step-list",
            "steps": [
              "nie wykonujesz już akcji w tej rundzie;",
              "zdobądź punkty z użytego boostera, jeśli zawiera efekt pasowania;",
              "wybierz nowy dostępny booster;",
              "odłóż stary booster;",
              "zajmij pierwsze wolne miejsce kolejności następnej rundy."
            ]
          },
          {
            "type": "paragraph",
            "text": "Nie można spasować i wrócić do gry w tej samej rundzie."
          }
        ]
      },
      {
        "title": "19. Cele rund i cele końcowe",
        "content": [
          {
            "type": "paragraph",
            "text": "Cel rundy punktuje konkretne czynności wykonane w bieżącej rundzie. Sprawdź go w chwili wykonania akcji, nie na końcu rundy, chyba że kafel mówi inaczej."
          },
          {
            "type": "paragraph",
            "text": "Cele końcowe porównują graczy po 6. rundzie. Gracze zajmują miejsca i otrzymują punkty według tabeli. Wirtualny gracz neutralny może uczestniczyć w rankingu w rozgrywkach o mniejszej liczbie graczy."
          }
        ]
      },
      {
        "title": "20. Zaginiona Flota",
        "content": [
          {
            "type": "paragraph",
            "text": "Dodatek zmienia mapę i dodaje eksplorację głębokiej przestrzeni."
          },
          {
            "type": "heading",
            "text": "Nowe obszary",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "pola międzysektorowe i głębokiej przestrzeni;",
              "asteroidy i protoplanety;",
              "miejsca docelowe dla statków;",
              "plansze eksploracji."
            ]
          },
          {
            "type": "heading",
            "text": "Statki i akcja Eksploracji",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Aby wykonać akcję Eksploracji:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz legalny statek lub planszę;",
              "sprawdź koszt podany na planszy eksploracji — często obejmuje 5 PZ, ale zdolności i frakcje mogą go zmieniać;",
              "wybierz dostępny prom/znacznik eksploracji;",
              "sprawdź zasięg z własnych struktur;",
              "umieść znacznik i wykonaj nagrodę lub odblokuj akcję;",
              "zastosuj zasady blokowania i kolejności."
            ]
          },
          {
            "type": "paragraph",
            "text": "Nie wpisuj uniwersalnego kosztu bez sprawdzenia konkretnej planszy."
          },
          {
            "type": "heading",
            "text": "Nowe frakcje",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "Darkanianie;",
              "Moweydowie;",
              "Kosmiczni Giganci;",
              "Tinkeroidzi."
            ]
          },
          {
            "type": "paragraph",
            "text": "Każda wymaga osobnego setupu i katalogu zdolności. [DO WERYFIKACJI: pełne plansze frakcji]."
          },
          {
            "type": "heading",
            "text": "Artefakty, technologie i federacje",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Dodatek wprowadza nowe artefakty, technologie, boostery i tokeny federacji. Ich tekst ma pierwszeństwo przed zasadą ogólną. Każdy element musi być filtrowany przez moduł lost-fleet."
          }
        ],
        "requiredAddons": [
          "lost-fleet"
        ]
      },
      {
        "title": "21. Koniec gry i punktowanie",
        "content": [
          {
            "type": "paragraph",
            "text": "Po 6. rundzie:"
          },
          {
            "type": "step-list",
            "steps": [
              "rozpatrz dwa cele końcowe;",
              "przyznaj punkty za pozycje na torach badań;",
              "przelicz pozostałe zasoby według oficjalnego kursu;",
              "dodaj punkty technologii, frakcji i dodatku;",
              "rozstrzygnij remis."
            ]
          },
          {
            "type": "paragraph",
            "text": "Aplikacja musi zawierać kalkulator i przykład końcowego liczenia."
          }
        ]
      }
    ],
    "firstGame": [
      {
        "type": "step-list",
        "steps": [
          "zagraj bez Zaginionej Floty;",
          "wybierz frakcje o prostych zdolnościach;",
          "ustaw rekomendowaną mapę;",
          "w 1. rundzie wykonaj co najmniej jedną kopalnię i jedno ulepszenie;",
          "pokaż cykl mocy na fizycznych znacznikach;",
          "wyjaśnij, że pasowanie ustala kolejność;",
          "federacje i zaawansowane technologie omów przed 3. rundą."
        ]
      }
    ],
    "quickReference": [
      {
        "type": "paragraph",
        "text": "Dochód → Gaja → akcje naprzemienne → pasowanie → porządkowanie. Akcje: kopalnia, Gaia, ulepszenie, federacja, badania, moc/Q.I.C., specjalna, pas. Budowa: zasięg + terraforming + koszt kopalni. Federacja: wymagana moc + minimalne satelity + token. Koniec: cele końcowe + badania + zasoby + efekty."
      }
    ],
    "mistakes": [
      {
        "type": "step-list",
        "steps": [
          "Traktowanie ładowania mocy jak dobierania nowych znaczników.",
          "Pomijanie kosztu terraformingu.",
          "Zostawianie częściowo terraformowanej planety.",
          "Wliczanie satelitów do wartości federacji.",
          "Używanie jednego budynku w wielu niezależnych federacjach.",
          "Dobieranie technologii przy każdym ulepszeniu.",
          "Wykonywanie akcji po spasowaniu.",
          "Łączenie podstawowych akcji Q.I.C. z ich zastępstwami z Zaginionej Floty."
        ]
      }
    ],
    "faq": [
      {
        "type": "paragraph",
        "text": "Czy mogę zbudować kopalnię na planecie zajętej przez przeciwnika? Nie."
      },
      {
        "type": "paragraph",
        "text": "Czy planeta w zasięgu musi być połączona prostą linią? Nie. Liczy się najmniejsza liczba połączeń między polami."
      },
      {
        "type": "paragraph",
        "text": "Czy mogę odmówić pasywnego ładowania mocy? Tak."
      },
      {
        "type": "paragraph",
        "text": "Czy palenie mocy jest akcją główną? Nie, jest czynnością darmową wykonywaną w dozwolonym momencie."
      },
      {
        "type": "paragraph",
        "text": "Czy po Projekcie Gaja kopalnia powstaje automatycznie? Nie. Po ukończeniu transformacji potrzebna jest osobna akcja budowy."
      },
      {
        "type": "paragraph",
        "text": "Czy mogę wziąć zaawansowaną technologię bez przykrywania standardowej? Nie, chyba że wyraźna zdolność mówi inaczej."
      },
      {
        "type": "paragraph",
        "text": "Czy booster pozostaje po pasowaniu? Wybierasz nowy booster dla następnej rundy."
      }
    ],
    "glossary": [
      {
        "type": "step-list",
        "steps": [
          "Gaiaformer — element inicjujący Projekt Gaja.",
          "Q.I.C. — rzadki zasób technologiczny.",
          "Satelita — znacznik łączący struktury federacji.",
          "Federacja — połączona sieć własnych struktur.",
          "Transdim — planeta wymagająca Projektu Gaja.",
          "Palenie mocy — usunięcie jednego znacznika z misy II w celu przesunięcia innego do misy III.",
          "Booster — kafel rundy zapewniający dochód, akcję lub punkty przy pasowaniu."
        ]
      }
    ],
    "examples": [],
    "components": [
      {
        "type": "step-list",
        "steps": [
          "modułowa mapa kosmosu;",
          "planety w różnych kolorach;",
          "plansze frakcji;",
          "kopalnie, stacje handlowe, laboratoria, akademie i instytut planetarny;",
          "zasoby: kredyty, ruda, wiedza i Q.I.C.;",
          "znaczniki mocy w trzech misach;",
          "tory badań;",
          "technologie standardowe i zaawansowane;",
          "kafle federacji;",
          "boostery rund;",
          "cele rund i cele końcowe;",
          "Gaiaformery i planety Transdim;",
          "w Zaginionej Flocie: sektory głębokiej przestrzeni, statki, plansze eksploracji, artefakty, nowe technologie, boostery, punktowanie i cztery frakcje."
        ]
      },
      {
        "type": "heading",
        "text": "Kredyty",
        "level": 1
      },
      {
        "type": "paragraph",
        "text": "Najczęściej opłacają budynki, ulepszenia i inne koszty gospodarcze."
      },
      {
        "type": "heading",
        "text": "Ruda",
        "level": 1
      },
      {
        "type": "paragraph",
        "text": "Służy głównie do budowy i terraforming."
      },
      {
        "type": "heading",
        "text": "Wiedza",
        "level": 1
      },
      {
        "type": "paragraph",
        "text": "Pozwala awansować na torach badań."
      },
      {
        "type": "heading",
        "text": "Q.I.C.",
        "level": 1
      },
      {
        "type": "paragraph",
        "text": "Rzadki zasób wykorzystywany m.in. do zwiększania zasięgu, niektórych akcji specjalnych i efektów technologii."
      },
      {
        "type": "paragraph",
        "text": "Zasobów nie można wydawać ponad stan. Limity na torach planszy frakcji są twarde; nadwyżka zazwyczaj przepada, chyba że efekt mówi inaczej."
      }
    ],
    "scoring": [
      {
        "type": "paragraph",
        "text": "Przez 6 rund rozwijasz międzygwiezdną cywilizację. Kolonizujesz planety, ulepszasz budynki, rozwijasz technologie, tworzysz federacje i wykonujesz Projekty Gaja. Zdobywasz punkty w trakcie gry, za cele rund oraz na końcu za cele końcowe, pozycje na torach badań i pozostałe zasoby."
      },
      {
        "type": "paragraph",
        "text": "Wygrywa gracz z największą liczbą punktów. Remisy rozstrzyga się według oficjalnej kolejności zapisanej w sekcji punktowania i katalogu wariantu. [DO WERYFIKACJI: dokładna reguła remisu właściwego wydania]."
      },
      {
        "type": "paragraph",
        "text": "Po 6. rundzie:"
      },
      {
        "type": "step-list",
        "steps": [
          "rozpatrz dwa cele końcowe;",
          "przyznaj punkty za pozycje na torach badań;",
          "przelicz pozostałe zasoby według oficjalnego kursu;",
          "dodaj punkty technologii, frakcji i dodatku;",
          "rozstrzygnij remis."
        ]
      },
      {
        "type": "paragraph",
        "text": "Aplikacja musi zawierać kalkulator i przykład końcowego liczenia."
      }
    ]
  },
  "weather-machine": {
    "chapters": [
      {
        "title": "1. Cel gry",
        "content": [
          {
            "type": "paragraph",
            "text": "Gracze są naukowcami współpracującymi z profesorem Lativem nad maszyną kontrolującą pogodę. Zdobywają punkty klimatu przez badania, eksperymenty, prototypy, publikacje, cytowania, dotacje i udział w naprawianiu skutków maszyny."
          },
          {
            "type": "paragraph",
            "text": "Gra kończy się, gdy zostanie uruchomiony jeden z głównych sygnałów końca, m.in. przyznanie Nagrody Nobla, zapełnienie odpowiedniego obszaru Rządu lub R&D albo wyczerpanie eksperymentów. Po dokończeniu wymaganej części gry następuje punktowanie końcowe."
          }
        ]
      },
      {
        "title": "2. Cztery lokalizacje",
        "content": [
          {
            "type": "paragraph",
            "text": "Plansza skupia się na czterech miejscach:"
          },
          {
            "type": "heading",
            "text": "Zaopatrzenie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Pozyskujesz i zarządzasz zapleczem:"
          },
          {
            "type": "step-list",
            "steps": [
              "rozbudowujesz warsztat;",
              "konstruujesz bota;",
              "zdobywasz inicjatywę;",
              "pobierasz albo zwracasz chemikalia."
            ]
          },
          {
            "type": "heading",
            "text": "Rząd",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Współpracujesz z administracją:"
          },
          {
            "type": "step-list",
            "steps": [
              "sprzedajesz część maszyny;",
              "zabezpieczasz dotację;",
              "rozwijasz finansowanie i realizujesz wymagania Rządu."
            ]
          },
          {
            "type": "heading",
            "text": "Laboratorium Lativa",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Pracujesz bezpośrednio przy eksperymentach:"
          },
          {
            "type": "step-list",
            "steps": [
              "dostarczasz boty i chemikalia;",
              "przygotowujesz eksperyment;",
              "publikujesz artykuły;",
              "korzystasz z cytowań."
            ]
          },
          {
            "type": "heading",
            "text": "Badania i Rozwój",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Rozwijasz technologię:"
          },
          {
            "type": "step-list",
            "steps": [
              "prowadzisz badanie;",
              "osiągasz przełom;",
              "budujesz prototyp;",
              "przygotowujesz naukowy wkład do przyszłych eksperymentów."
            ]
          }
        ]
      },
      {
        "title": "3. Najważniejsze zasoby",
        "content": [
          {
            "type": "step-list",
            "steps": [
              "naukowiec — wskazuje aktualną lokalizację;",
              "boty — wykonują pracę i zajmują miejsca;",
              "chemikalia — wymagane przez eksperymenty i projekty;",
              "części maszyny — wytwarzane i sprzedawane;",
              "kupony — opłacają określone czynności w lokalizacjach;",
              "żetony badań — rozwijają dziedziny i publikacje;",
              "kafle warsztatu — zwiększają pojemność i możliwości;",
              "znaczniki finansowania oraz inicjatywy;",
              "plany eksperymentów, prototypów i publikacji."
            ]
          }
        ]
      },
      {
        "title": "4. Przygotowanie",
        "content": [
          {
            "type": "checklist",
            "id": "setup-checklist",
            "title": "Kontrola przygotowania",
            "items": [
              "Przeczytaj kolejność przygotowania przed wyjęciem komponentów.",
              "Wykonaj kroki po kolei i sprawdź konfigurację graczy."
            ]
          },
          {
            "type": "step-list",
            "steps": [
              "Rozłóż planszę główną i plansze eksperymentów.",
              "Przygotuj cztery lokalizacje i ich wystawki.",
              "Rozłóż kafle badań, prototypów, publikacji i dotacji.",
              "Przygotuj maszynę pogodową, regiony oraz typy pogody.",
              "Ustaw profesora Lativa, asystenta i znaczniki inicjatywy.",
              "Każdy gracz bierze planszę, naukowca, boty, znaczniki i zasoby startowe.",
              "Rozdaj lub wybierz cele i elementy początkowe zgodnie z liczbą graczy.",
              "Zablokuj pola niedostępne przy mniejszej liczbie graczy.",
              "Ustal pierwszego gracza."
            ]
          },
          {
            "type": "paragraph",
            "text": "[DO WERYFIKACJI: dokładne liczby komponentów startowych i blokady pól dla 2/3/4 graczy]."
          }
        ]
      },
      {
        "title": "5. Runda",
        "content": [
          {
            "type": "paragraph",
            "text": "Każda runda ma trzy fazy: A. Tury graczy. B. Uruchomienie eksperymentu. C. Koniec rundy."
          }
        ]
      },
      {
        "title": "6. Faza A — tury graczy",
        "content": [
          {
            "type": "paragraph",
            "text": "W swojej turze wykonaj kolejno:"
          },
          {
            "type": "heading",
            "text": "Krok 1. Opcjonalnie użyj jednego kafla",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Możesz wykorzystać jeden posiadany kafel Dotacji albo Inwestycji, jeśli spełniasz warunki. Kafel określa efekt, koszt i czy jest odrzucany/odwracany."
          },
          {
            "type": "heading",
            "text": "Krok 2. Przenieś naukowca",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Przenieś naukowca do legalnej lokalizacji. Zasady ruchu mogą ograniczać pozostanie w miejscu albo wybór kolejnej lokalizacji. Po wejściu do Laboratorium Lativa możesz przesunąć Lativa zgodnie z regułą tej lokalizacji."
          },
          {
            "type": "heading",
            "text": "Krok 3. Wykonaj akcję lokalizacji",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Wykonaj jedną z dostępnych akcji, opłać koszt kuponami i zasobami, umieść boty albo znaczniki tam, gdzie wymaga tego plansza."
          },
          {
            "type": "heading",
            "text": "Krok 4. Akcje dodatkowe i badania",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Rozpatrz dozwolone akcje dodatkowe, efekty warsztatu, torów i kafli. Umieść żetony badań na odpowiednich obszarach, jeśli wykonałeś badanie."
          },
          {
            "type": "paragraph",
            "text": "Nie wolno przerwać nierozdzielnego efektu inną akcją, chyba że symbol oznacza akcję darmową."
          }
        ]
      },
      {
        "title": "7. Kupony",
        "content": [
          {
            "type": "paragraph",
            "text": "Kupony są wyspecjalizowaną walutą akcji. Kolor lub symbol kuponu wskazuje, gdzie może zostać użyty."
          },
          {
            "type": "step-list",
            "steps": [
              "kupon wydaje się przy wykonaniu akcji;",
              "nie zastępuje brakującego bota lub chemikalium;",
              "uniwersalny kupon może zastąpić wskazany typ tylko zgodnie z ikoną;",
              "limit przechowywania jest określony przez planszę gracza i warsztat;",
              "nadwyżka przepada, jeśli efekt nie daje innego rozwiązania."
            ]
          }
        ]
      },
      {
        "title": "8. Warsztat",
        "content": [
          {
            "type": "paragraph",
            "text": "Warsztat kontroluje:"
          },
          {
            "type": "step-list",
            "steps": [
              "maksymalną liczbę dostępnych botów;",
              "miejsce na części;",
              "pojemność chemikaliów/kuponów;",
              "dodatkowe efekty i ulepszenia."
            ]
          },
          {
            "type": "paragraph",
            "text": "Rozbudowując warsztat:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz legalne pole;",
              "zapłać koszt;",
              "umieść kafel;",
              "natychmiast odblokuj nową pojemność lub zdolność;",
              "nie otrzymuj elementów automatycznie, jeśli kafel tylko zwiększa limit."
            ]
          }
        ]
      },
      {
        "title": "9. Boty",
        "content": [
          {
            "type": "paragraph",
            "text": "Bot może:"
          },
          {
            "type": "step-list",
            "steps": [
              "pracować przy eksperymencie;",
              "uczestniczyć w prototypie;",
              "zajmować pole projektu;",
              "zostać wykorzystany przez efekt lokalizacji."
            ]
          },
          {
            "type": "paragraph",
            "text": "Bot umieszczony na planszy nie jest dostępny w rezerwie. Wraca tylko w chwili wskazanej przez eksperyment, koniec rundy lub efekt."
          },
          {
            "type": "paragraph",
            "text": "Konstruowanie bota zwiększa liczbę elementów, którymi możesz dysponować, ale wymaga miejsca w warsztacie."
          }
        ]
      },
      {
        "title": "10. Chemikalia",
        "content": [
          {
            "type": "paragraph",
            "text": "Chemikalia mają typy/kolory. Podczas płatności musisz użyć właściwej kombinacji. Nie można zamienić koloru bez efektu dżokera."
          },
          {
            "type": "paragraph",
            "text": "Pobieranie i zwracanie chemikaliów może wpływać na inicjatywę lub dostępność w puli. Aplikacja powinna pokazywać dokładną sekwencję pobrania i uzupełnienia wystawki."
          }
        ]
      },
      {
        "title": "11. Rząd",
        "content": [
          {
            "type": "heading",
            "text": "Sprzedaż części maszyny",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz dostępne zlecenie lub pole;",
              "oddaj wymagane części;",
              "umieść swój znacznik/bota, jeśli wymaga tego pole;",
              "odbierz wskazaną nagrodę;",
              "przesuń odpowiedni tor finansowania."
            ]
          },
          {
            "type": "heading",
            "text": "Dotacja",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Dotacja daje jednorazową albo trwałą korzyść, ale wymaga spełnienia warunku. Katalog każdej dotacji musi podawać:"
          },
          {
            "type": "step-list",
            "steps": [
              "moment użycia;",
              "koszt;",
              "czy kafel się odwraca;",
              "czy działa w tej samej turze, w której został zdobyty."
            ]
          },
          {
            "type": "paragraph",
            "text": "Zapełnienie obszaru Rządu może uruchomić koniec gry."
          }
        ]
      },
      {
        "title": "12. Laboratorium Lativa",
        "content": [
          {
            "type": "paragraph",
            "text": "To główne miejsce przygotowywania i uruchamiania eksperymentów."
          },
          {
            "type": "heading",
            "text": "Praca nad eksperymentem",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz aktywny typ pogody/gałąź;",
              "umieść wymagane boty i chemikalia;",
              "zdobądź wkład/bonus pola;",
              "oznacz swoje uczestnictwo;",
              "nie odzyskuj elementów do chwili rozliczenia, jeśli plansza tak wskazuje."
            ]
          },
          {
            "type": "heading",
            "text": "Publikacja",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Publikacja wymaga odpowiednich badań/tomów i często powiązania z przeprowadzonym eksperymentem. Po opublikowaniu:"
          },
          {
            "type": "step-list",
            "steps": [
              "zdobądź punkty i nagrody;",
              "umieść znacznik;",
              "udostępnij możliwość cytowania innym graczom."
            ]
          },
          {
            "type": "heading",
            "text": "Cytowanie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Cytujący korzysta z cudzej publikacji, a autor otrzymuje rekompensatę. Dokładne koszty i punkty muszą być zdefiniowane w danych publikacji."
          }
        ]
      },
      {
        "title": "13. R&D",
        "content": [
          {
            "type": "heading",
            "text": "Badanie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Wybierz dziedzinę, zapłać koszt i umieść/zdobądź żeton badań. Badania są wymagane przez prototypy, publikacje i eksperymenty."
          },
          {
            "type": "heading",
            "text": "Przełom",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Przełom jest silniejszym etapem rozwoju. Może odblokować:"
          },
          {
            "type": "step-list",
            "steps": [
              "nowy efekt;",
              "miejsce prototypu;",
              "punkty;",
              "przewagę w eksperymencie."
            ]
          },
          {
            "type": "heading",
            "text": "Prototyp",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz dostępny prototyp;",
              "spełnij wymagania badań;",
              "dostarcz części, boty i chemikalia;",
              "umieść znacznik;",
              "odbierz efekt i punkty."
            ]
          },
          {
            "type": "paragraph",
            "text": "Zapełnienie obszaru R&D może uruchomić koniec gry."
          }
        ]
      },
      {
        "title": "14. Faza B — eksperyment",
        "content": [
          {
            "type": "paragraph",
            "text": "Po zakończeniu tur wszystkich graczy sprawdź aktywną gałąź maszyny pogodowej."
          },
          {
            "type": "paragraph",
            "text": "Eksperyment zostaje uruchomiony, jeżeli spełniono wszystkie wymagane warunki:"
          },
          {
            "type": "step-list",
            "steps": [
              "wymagane pola mają wkład;",
              "dostępny jest właściwy eksperyment;",
              "asystent/Lativ znajduje się w odpowiednim miejscu;",
              "nie blokuje go szczególna reguła."
            ]
          },
          {
            "type": "heading",
            "text": "Rozpatrywanie",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "potwierdź typ pogody;",
              "sprawdź wkład graczy;",
              "rozpatrz efekt maszyny;",
              "przyznaj nagrody i punkty;",
              "zwróć lub przesuń boty i chemikalia zgodnie z ikonami;",
              "zaktualizuj tory i wystawki;",
              "przenieś asystenta/znacznik aktywnej gałęzi."
            ]
          },
          {
            "type": "paragraph",
            "text": "Jeśli warunki nie są spełnione, eksperyment nie działa. Nie wypłacaj częściowych nagród."
          }
        ]
      },
      {
        "title": "15. Faza C — koniec rundy",
        "content": [
          {
            "type": "step-list",
            "steps": [
              "odśwież wskazane kafle;",
              "uzupełnij wystawki;",
              "przesuń znaczniki pogody i rundy;",
              "ustal inicjatywę;",
              "sprawdź sygnały końca gry;",
              "przygotuj kolejną rundę."
            ]
          }
        ]
      },
      {
        "title": "16. Inicjatywa",
        "content": [
          {
            "type": "paragraph",
            "text": "Tor inicjatywy decyduje o kolejności graczy. Nie zawsze wygrywa gracz, który pierwszy dotarł na pole — stosuj regułę nakładania znaczników."
          },
          {
            "type": "paragraph",
            "text": "Każde źródło zmiany inicjatywy powinno być linkowane z Search."
          }
        ]
      },
      {
        "title": "17. Sygnały końca gry",
        "content": [
          {
            "type": "paragraph",
            "text": "Koniec może zostać uruchomiony, gdy:"
          },
          {
            "type": "step-list",
            "steps": [
              "przyznano Nagrodę Nobla;",
              "odpowiedni obszar Rządu został zapełniony;",
              "odpowiedni obszar R&D został zapełniony;",
              "zabrakło kolejnych kafli eksperymentów."
            ]
          },
          {
            "type": "paragraph",
            "text": "Po sygnale wykonaj dokładnie liczbę tur/rund wskazaną w oficjalnej procedurze. [DO WERYFIKACJI: kolejność dokończenia dla każdego triggera]."
          }
        ]
      },
      {
        "title": "18. Punktowanie",
        "content": [
          {
            "type": "paragraph",
            "text": "Punkty można zdobywać za:"
          },
          {
            "type": "step-list",
            "steps": [
              "eksperymenty;",
              "prototypy;",
              "publikacje;",
              "cytowania;",
              "pozycje na torach;",
              "dotacje i inwestycje;",
              "cele;",
              "rozwinięty warsztat;",
              "pozostałe elementy wskazane ikonami końcowymi."
            ]
          },
          {
            "type": "paragraph",
            "text": "W aplikacji utwórz jeden wspólny model ScoringRule[], z którego korzystają pełne zasady, Quick Reference i kalkulator."
          }
        ]
      }
    ],
    "firstGame": [
      {
        "type": "step-list",
        "steps": [
          "Wyjaśnij tylko cztery lokalizacje i trzy fazy rundy.",
          "Pokaż, że naukowiec wskazuje miejsce wykonania akcji.",
          "W pierwszej rundzie każdy powinien rozbudować warsztat albo zbudować bota.",
          "Przed eksperymentem wspólnie sprawdź wszystkie wymagania.",
          "Publikacje i cytowania omów dopiero, gdy pierwszy gracz ma wymagane badania.",
          "Użyj Guided z checklistą elementów pozostawionych przy eksperymencie."
        ]
      }
    ],
    "quickReference": [
      {
        "type": "paragraph",
        "text": "Runda: A. opcjonalny kafel → ruch naukowca → akcja lokalizacji → akcje dodatkowe; B. sprawdzenie i uruchomienie eksperymentu; C. odświeżenie, inicjatywa, triggery końca."
      },
      {
        "type": "paragraph",
        "text": "Lokalizacje:"
      },
      {
        "type": "step-list",
        "steps": [
          "Zaopatrzenie: warsztat, bot, inicjatywa, chemikalia.",
          "Rząd: części, dotacje.",
          "Laboratorium: eksperyment, publikacja, cytowanie.",
          "R&D: badanie, przełom, prototyp."
        ]
      }
    ],
    "mistakes": [
      {
        "type": "step-list",
        "steps": [
          "Traktowanie zwiększenia limitu jako natychmiastowego otrzymania zasobu.",
          "Zabieranie bota z eksperymentu przed jego rozliczeniem.",
          "Używanie kuponu jako dowolnego zasobu.",
          "Wypłacanie częściowej nagrody za nieuruchomiony eksperyment.",
          "Pomijanie kolejności inicjatywy.",
          "Publikowanie bez spełnienia wszystkich badań.",
          "Mylenie sygnału końca z natychmiastowym przerwaniem gry."
        ]
      }
    ],
    "faq": [
      {
        "type": "paragraph",
        "text": "Czy muszę użyć kafla dotacji na początku tury? Nie, jeśli jest opcjonalny. Jeśli go używasz, zrób to w określonym kroku."
      },
      {
        "type": "paragraph",
        "text": "Czy mogę pozostać w tej samej lokalizacji? Tylko gdy reguła ruchu albo efekt specjalny na to pozwala."
      },
      {
        "type": "paragraph",
        "text": "Czy bot wraca od razu po umieszczeniu? Nie. Wraca w chwili wskazanej przez pole lub fazę eksperymentu."
      },
      {
        "type": "paragraph",
        "text": "Czy można przygotować eksperyment, który nie uruchomi się w tej rundzie? Tak, jeśli pole i aktualny stan planszy na to pozwalają; elementy pozostają zgodnie z zasadami."
      },
      {
        "type": "paragraph",
        "text": "Czy trigger końca kończy grę natychmiast? Nie. Najpierw wykonuje się oficjalną procedurę dokończenia."
      }
    ],
    "glossary": [
      {
        "type": "step-list",
        "steps": [
          "Eksperyment — wspólny projekt uruchamiany w Fazie B.",
          "Prototyp — indywidualne osiągnięcie tworzone w R&D.",
          "Publikacja — naukowy wynik pozwalający zdobywać punkty i cytowania.",
          "Kupon — wyspecjalizowany koszt akcji.",
          "Bot — pracownik umieszczany na projektach.",
          "Warsztat — plansza pojemności i silnika gracza.",
          "Inicjatywa — kolejność tur w rundzie."
        ]
      }
    ],
    "examples": [
      {
        "type": "paragraph",
        "text": "Anna używa kafla inwestycji. Następnie przenosi naukowca z Zaopatrzenia do R&D. Wydaje właściwy kupon, wykonuje badanie i umieszcza żeton w dziedzinie potrzebnej do prototypu. Dzięki efektowi warsztatu może następnie wykonać akcję dodatkową, ale nie przerywa nią umieszczania żetonu. Na końcu aktualizuje swój stan i przekazuje turę."
      }
    ],
    "components": [
      {
        "type": "step-list",
        "steps": [
          "naukowiec — wskazuje aktualną lokalizację;",
          "boty — wykonują pracę i zajmują miejsca;",
          "chemikalia — wymagane przez eksperymenty i projekty;",
          "części maszyny — wytwarzane i sprzedawane;",
          "kupony — opłacają określone czynności w lokalizacjach;",
          "żetony badań — rozwijają dziedziny i publikacje;",
          "kafle warsztatu — zwiększają pojemność i możliwości;",
          "znaczniki finansowania oraz inicjatywy;",
          "plany eksperymentów, prototypów i publikacji."
        ]
      }
    ],
    "scoring": [
      {
        "type": "paragraph",
        "text": "Gracze są naukowcami współpracującymi z profesorem Lativem nad maszyną kontrolującą pogodę. Zdobywają punkty klimatu przez badania, eksperymenty, prototypy, publikacje, cytowania, dotacje i udział w naprawianiu skutków maszyny."
      },
      {
        "type": "paragraph",
        "text": "Gra kończy się, gdy zostanie uruchomiony jeden z głównych sygnałów końca, m.in. przyznanie Nagrody Nobla, zapełnienie odpowiedniego obszaru Rządu lub R&D albo wyczerpanie eksperymentów. Po dokończeniu wymaganej części gry następuje punktowanie końcowe."
      },
      {
        "type": "paragraph",
        "text": "Punkty można zdobywać za:"
      },
      {
        "type": "step-list",
        "steps": [
          "eksperymenty;",
          "prototypy;",
          "publikacje;",
          "cytowania;",
          "pozycje na torach;",
          "dotacje i inwestycje;",
          "cele;",
          "rozwinięty warsztat;",
          "pozostałe elementy wskazane ikonami końcowymi."
        ]
      },
      {
        "type": "paragraph",
        "text": "W aplikacji utwórz jeden wspólny model ScoringRule[], z którego korzystają pełne zasady, Quick Reference i kalkulator."
      }
    ]
  },
  "voidfall": {
    "chapters": [
      {
        "title": "1. Charakter gry",
        "content": [
          {
            "type": "paragraph",
            "text": "Voidfall łączy zarządzanie imperium euro z eksploracją, rozwojem technologii i deterministyczną walką 4X. Gra ma trzy tryby:"
          },
          {
            "type": "step-list",
            "steps": [
              "rywalizacyjny;",
              "kooperacyjny;",
              "solo."
            ]
          },
          {
            "type": "paragraph",
            "text": "Każdy scenariusz określa mapę, liczbę Cykli, specjalne zasady, Cele, konfigurację Voidborn i warunki końca."
          }
        ]
      },
      {
        "title": "2. Cel",
        "content": [
          {
            "type": "paragraph",
            "text": "W trybie rywalizacyjnym zdobywasz Wpływ przez rozwój sektorów, realizację Agend, wydarzenia Cykli, walkę i kontrolę. Wygrywa największy wynik po trzecim Cyklu."
          },
          {
            "type": "paragraph",
            "text": "W kooperacji i solo gracze muszą jednocześnie osiągnąć wspólny cel i uniknąć warunków porażki, takich jak nadmierna siła Voidborn, nieopanowane Kryzysy albo niewykonane wymagania scenariusza."
          }
        ]
      },
      {
        "title": "3. Przygotowanie",
        "content": [
          {
            "type": "checklist",
            "id": "setup-checklist",
            "title": "Kontrola przygotowania",
            "items": [
              "Przeczytaj kolejność przygotowania przed wyjęciem komponentów.",
              "Wykonaj kroki po kolei i sprawdź konfigurację graczy."
            ]
          },
          {
            "type": "step-list",
            "steps": [
              "Wybierz tryb i scenariusz.",
              "Zbuduj mapę dokładnie według diagramu scenariusza.",
              "Umieść sektory, populację, Gildie, floty i znaczniki Skażenia.",
              "Przygotuj Voidborn, Fallen Houses i cele.",
              "Każdy wybiera frakcję i Dom, bierze plansze, technologie, floty, Focus cards i zasoby.",
              "Ustaw trzy wskaźniki zasobów: wartość produkcji, zapas i limity zgodnie z planszą.",
              "Przygotuj wydarzenia Cykli, Agendy i rynek technologii.",
              "Dla kooperacji/solo przygotuj Kryzysy, priorytety Voidborn i elementy automy."
            ]
          },
          {
            "type": "paragraph",
            "text": "Nie wolno użyć setupu „z pamięci”. Aplikacja musi mieć dane dla każdego scenariusza. [DO WERYFIKACJI: wszystkie mapy i liczby startowe]."
          }
        ]
      },
      {
        "title": "4. Trzy Cykle",
        "content": [
          {
            "type": "paragraph",
            "text": "Partia trwa trzy Cykle. Każdy Cykl obejmuje:"
          },
          {
            "type": "step-list",
            "steps": [
              "przygotowanie i wydarzenie Cykli;",
              "naprzemienne tury graczy z kartami Skupienia;",
              "ocenę Cykli, produkcję, rozliczenie celów i porządkowanie."
            ]
          },
          {
            "type": "paragraph",
            "text": "Scenariusz może zmieniać nazwy lub kolejność części."
          }
        ]
      },
      {
        "title": "5. Karty Skupienia",
        "content": [
          {
            "type": "paragraph",
            "text": "Karta Skupienia definiuje zestaw powiązanych działań. W turze:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz legalną kartę z ręki;",
              "zagraj ją;",
              "wykonaj dozwoloną liczbę jej działań w legalnej kolejności;",
              "opłać każdy koszt;",
              "rozpatrz akcje dodatkowe i zdolności;",
              "odłóż kartę w miejsce zagranych kart."
            ]
          },
          {
            "type": "paragraph",
            "text": "[DO WERYFIKACJI: dokładna liczba wybieranych sekcji/akcji według aktualnego kompendium]."
          },
          {
            "type": "paragraph",
            "text": "Karty obejmują obszary takie jak:"
          },
          {
            "type": "step-list",
            "steps": [
              "produkcja;",
              "rozwój;",
              "badania;",
              "ekspansja;",
              "inwazja;",
              "polityka i Agendy;",
              "handel;",
              "oczyszczanie Skażenia."
            ]
          },
          {
            "type": "paragraph",
            "text": "Tekst karty ma pierwszeństwo przed regułą ogólną."
          }
        ]
      },
      {
        "title": "6. Zasoby: zapas i produkcja",
        "content": [
          {
            "type": "paragraph",
            "text": "Każdy główny zasób ma:"
          },
          {
            "type": "step-list",
            "steps": [
              "wartość produkcji;",
              "aktualny zapas."
            ]
          },
          {
            "type": "paragraph",
            "text": "Płacąc koszt, zmniejszasz zapas, nie produkcję, chyba że efekt mówi wyraźnie inaczej. Produkcja jest aktualizowana przez populację, Gildie, technologie i sektory, a następnie zasila zapas w odpowiedniej fazie."
          },
          {
            "type": "paragraph",
            "text": "Oficjalne FAQ wyjaśnia, że koszty pobiera się ze stockpile widocznego na prawych tarczach zasobów."
          }
        ]
      },
      {
        "title": "7. Populacja i sektory",
        "content": [
          {
            "type": "paragraph",
            "text": "Sektory zawierają:"
          },
          {
            "type": "step-list",
            "steps": [
              "planety;",
              "populację;",
              "miejsca Gildii;",
              "floty;",
              "obronę;",
              "Skażenie;",
              "potencjalne elementy Voidborn."
            ]
          },
          {
            "type": "paragraph",
            "text": "Zwiększenie populacji odblokowuje produkcję i miejsca rozwoju. Skażony sektor nadal może produkować, ale nie można w nim zmieniać populacji i nie liczy się jako Czysty, dopóki nie zostanie oczyszczony."
          }
        ]
      },
      {
        "title": "8. Gildie",
        "content": [
          {
            "type": "paragraph",
            "text": "Gildie są głównymi strukturami ekonomicznymi. Umieszczając lub ulepszając Gildię:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz legalny slot;",
              "opłać koszt;",
              "sprawdź populację i wymagania;",
              "umieść poziom Gildii;",
              "zaktualizuj produkcję;",
              "rozpatrz natychmiastowy efekt."
            ]
          },
          {
            "type": "paragraph",
            "text": "Każdy typ Gildii ma osobne działanie. Katalog gry musi opisywać wszystkie poziomy i ikony."
          }
        ]
      },
      {
        "title": "9. Technologie",
        "content": [
          {
            "type": "paragraph",
            "text": "Technologie:"
          },
          {
            "type": "step-list",
            "steps": [
              "dają nowe akcje;",
              "modyfikują koszty;",
              "zwiększają siłę floty;",
              "wpływają na produkcję i punktowanie;",
              "zmieniają zasady frakcji."
            ]
          },
          {
            "type": "paragraph",
            "text": "Zdobycie technologii nie oznacza automatycznego wykonania jej akcji. Akcje technologii należy uruchamiać w podanym momencie."
          }
        ]
      },
      {
        "title": "10. Floty",
        "content": [
          {
            "type": "paragraph",
            "text": "Floty reprezentują siłę wojskową w sektorze. Figurki lub znaczniki mogą oznaczać liczbę, klasę i siłę."
          },
          {
            "type": "paragraph",
            "text": "Ruch:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz źródłowy sektor;",
              "określ legalną trasę;",
              "sprawdź zasięg i połączenia;",
              "przenieś dozwoloną część floty;",
              "jeśli w sektorze docelowym są wrogie siły, rozpocznij Inwazję/Bitwę."
            ]
          },
          {
            "type": "paragraph",
            "text": "Nie wolno przechodzić przez blokujące elementy bez zdolności."
          }
        ]
      },
      {
        "title": "11. Walka",
        "content": [
          {
            "type": "paragraph",
            "text": "Walka jest deterministyczna. Nie używa standardowego rzutu kością."
          },
          {
            "type": "paragraph",
            "text": "Ogólny przebieg:"
          },
          {
            "type": "step-list",
            "steps": [
              "określ atakującego i obrońcę;",
              "ustal typy i siłę jednostek;",
              "zastosuj technologie i modyfikatory;",
              "rozpatrz salwy i absorpcję obrażeń;",
              "usuń straty;",
              "sprawdź wynik;",
              "przejmij lub obroń sektor;",
              "rozpatrz Skażenie, nagrody i skutki scenariusza."
            ]
          },
          {
            "type": "paragraph",
            "text": "Absorpcję danej salwy stosuje się tylko raz w jednym kroku salwy, zgodnie z oficjalną erratą. Dokładna tabela siły i kolejność typów flot muszą być odwzorowane z aktualnego kompendium. [DO WERYFIKACJI: Combat Reference]."
          }
        ]
      },
      {
        "title": "12. Inwazja Voidborn i Skirmish",
        "content": [
          {
            "type": "paragraph",
            "text": "Voidborn działają zgodnie z priorytetami trybu/scenariusza. Podczas Inwazji mogą czasowo przekroczyć zwykły limit mocy floty, jeśli aktualna errata tak stanowi. Po zakończeniu rozpatrz wymagane limity i straty."
          },
          {
            "type": "paragraph",
            "text": "Skirmish to uproszczone rozstrzygnięcie wykorzystywane przez część efektów. Nie należy utożsamiać go z pełną Bitwą."
          }
        ]
      },
      {
        "title": "13. Skażenie",
        "content": [
          {
            "type": "paragraph",
            "text": "Skażenie:"
          },
          {
            "type": "step-list",
            "steps": [
              "ogranicza rozwój sektora;",
              "blokuje zmianę populacji;",
              "może wpływać na punktowanie i status Czystego sektora;",
              "nie wyłącza automatycznie produkcji."
            ]
          },
          {
            "type": "paragraph",
            "text": "Oczyszczanie wymaga konkretnej akcji i kosztu. Usunięcie Skażenia może natychmiast odblokować dalsze możliwości, ale nie daje dodatkowej akcji, jeśli efekt tego nie mówi."
          }
        ]
      },
      {
        "title": "14. Agendy i tokeny Handlu",
        "content": [
          {
            "type": "paragraph",
            "text": "Agendy określają cele lub jednorazowe możliwości."
          },
          {
            "type": "paragraph",
            "text": "Oficjalne FAQ:"
          },
          {
            "type": "step-list",
            "steps": [
              "zdobytej Agendy albo tokena Handlu nie można użyć w tej samej turze, w której został zdobyty;",
              "wybór premii Handlu następuje zgodnie z kolejnością wskazaną przez jego efekt;",
              "tekst Agendy może zmieniać zasadę ogólną."
            ]
          },
          {
            "type": "paragraph",
            "text": "Aplikacja musi pilnować stanu acquiredThisTurn."
          }
        ]
      },
      {
        "title": "15. Wydarzenia Cykli",
        "content": [
          {
            "type": "paragraph",
            "text": "Na początku lub podczas Cykli wchodzą w życie wydarzenia:"
          },
          {
            "type": "step-list",
            "steps": [
              "zmieniają punktowanie;",
              "dodają zasady;",
              "modyfikują mapę;",
              "wzmacniają Voidborn;",
              "tworzą nowe cele."
            ]
          },
          {
            "type": "paragraph",
            "text": "Każde wydarzenie musi mieć:"
          },
          {
            "type": "step-list",
            "steps": [
              "moment wejścia;",
              "okres działania;",
              "kolejność z Agendami i technologiami;",
              "koniec działania;",
              "przykład."
            ]
          }
        ]
      },
      {
        "title": "16. Akcje ekonomiczne",
        "content": [
          {
            "type": "paragraph",
            "text": "Typowe działania:"
          },
          {
            "type": "step-list",
            "steps": [
              "zwiększ populację;",
              "rozbuduj Gildię;",
              "produkuj;",
              "handluj;",
              "rozwijaj technologię;",
              "oczyść sektor;",
              "przemieszczaj flotę;",
              "wykonaj Inwazję;",
              "zdobądź Agendę;",
              "zyskaj Wpływ."
            ]
          },
          {
            "type": "paragraph",
            "text": "Dokładne koszty są na kartach i planszach. Nie wolno wprowadzać jednego „uśrednionego” kosztu."
          }
        ]
      },
      {
        "title": "17. Tryb rywalizacyjny",
        "content": [
          {
            "type": "step-list",
            "steps": [
              "gracze kontrolują własne sektory;",
              "mogą wchodzić w konflikt;",
              "zdobywają indywidualny Wpływ;",
              "Agendy i wydarzenia określają bieżące kierunki punktowania;",
              "interakcje dyplomatyczne nie pozwalają na przekazywanie zasobów bez reguły."
            ]
          }
        ]
      },
      {
        "title": "18. Tryb kooperacyjny",
        "content": [
          {
            "type": "paragraph",
            "text": "Gracze wspólnie mierzą się z Voidborn:"
          },
          {
            "type": "step-list",
            "steps": [
              "rozpatrują Kryzysy;",
              "używają priorytetów automy;",
              "mogą mieć wspólny limit czasu lub cel;",
              "przegrywają po spełnieniu dowolnego warunku porażki scenariusza."
            ]
          },
          {
            "type": "paragraph",
            "text": "Każda akcja automy musi mieć twardą listę priorytetów i regułę remisu."
          }
        ]
      },
      {
        "title": "19. Tryb solo",
        "content": [
          {
            "type": "paragraph",
            "text": "Solo używa zbliżonych systemów do kooperacji, ale wszystkie decyzje wieloosobowe mają ustalony priorytet. Nie wybieraj wyniku korzystniejszego dla gracza, jeżeli istnieje reguła automy."
          }
        ]
      },
      {
        "title": "20. Koniec Cykli",
        "content": [
          {
            "type": "paragraph",
            "text": "Na końcu Cykli:"
          },
          {
            "type": "step-list",
            "steps": [
              "rozpatrz aktualne wydarzenie i punktowanie;",
              "sprawdź cele;",
              "wykonaj produkcję/odświeżenie;",
              "przywróć karty i znaczniki;",
              "zaktualizuj Voidborn;",
              "przygotuj kolejny Cykl."
            ]
          },
          {
            "type": "paragraph",
            "text": "Po trzecim Cyklu wykonaj punktowanie końcowe i sprawdź warunek zwycięstwa właściwy dla trybu."
          }
        ]
      }
    ],
    "firstGame": [
      {
        "type": "step-list",
        "steps": [
          "Użyj rekomendowanego scenariusza szkoleniowego.",
          "Wybierz prostsze frakcje.",
          "Rozłóż mapę dokładnie z aplikacji.",
          "Guided powinien pokazać pierwszą kartę Skupienia.",
          "Pierwszą turę ekonomiczną przeprowadź bez skracania.",
          "Pierwszą walkę rozpatrz z interaktywnym kalkulatorem salw.",
          "Przed końcem Cyklu pokaż różnicę między zapasem a produkcją.",
          "Nie dołączaj zaawansowanych Agend przed zrozumieniem podstaw."
        ]
      }
    ],
    "quickReference": [
      {
        "type": "step-list",
        "steps": [
          "wybierz kartę Skupienia;",
          "wykonaj dozwolone akcje;",
          "płać z zapasu;",
          "aktualizuj produkcję osobno;",
          "sprawdź legalność sektora;",
          "walka: modyfikatory → salwy → absorpcja → straty → wynik;",
          "nie używaj nowej Agendy/tokena Handlu w tej samej turze;",
          "Skażony sektor produkuje, ale blokuje zmianę populacji i status Czysty;",
          "po Cyklu: cele, produkcja, odświeżenie, Voidborn."
        ]
      }
    ],
    "mistakes": [
      {
        "type": "step-list",
        "steps": [
          "Płacenie przez zmniejszenie produkcji.",
          "Traktowanie Skażonego sektora jako całkowicie wyłączonego.",
          "Użycie nowej Agendy w tej samej turze.",
          "Wielokrotne stosowanie absorpcji w jednej salwie.",
          "Rozstrzyganie pełnej Bitwy regułami Skirmish.",
          "Pomijanie wydarzenia Cykli.",
          "Używanie setupu innego scenariusza.",
          "Wybieranie priorytetu Voidborn na korzyść gracza."
        ]
      }
    ],
    "faq": [
      {
        "type": "paragraph",
        "text": "Czy Skażony sektor produkuje? Tak, chyba że konkretny efekt mówi inaczej. Nie można w nim zmieniać populacji i nie jest Czysty."
      },
      {
        "type": "paragraph",
        "text": "Czy płacę z wartości produkcji? Nie. Standardowo płacisz z zapasu."
      },
      {
        "type": "paragraph",
        "text": "Czy mogę użyć tokena Handlu od razu po zdobyciu? Nie w tej samej turze."
      },
      {
        "type": "paragraph",
        "text": "Czy walka jest losowa? Jej podstawowy system jest deterministyczny; zmienne wynikają z decyzji, technologii i efektów."
      },
      {
        "type": "paragraph",
        "text": "Czy scenariusze różnią tylko mapą? Nie. Mogą zmieniać cele, zasady, Voidborn i setup."
      },
      {
        "type": "paragraph",
        "text": "Czy mogę przekroczyć limit floty? Tylko w sytuacji wyraźnie dopuszczonej przez regułę lub erratę, np. podczas określonej Inwazji Voidborn."
      }
    ],
    "glossary": [
      {
        "type": "step-list",
        "steps": [
          "Cykl — jedna z trzech głównych części partii.",
          "Skupienie/Focus — karta określająca działania tury.",
          "Zapas — bieżąca ilość zasobu możliwa do wydania.",
          "Produkcja — wartość generująca zasoby w odpowiedniej fazie.",
          "Gildia — struktura gospodarcza w sektorze.",
          "Skażenie — stan sektora ograniczający jego rozwój.",
          "Voidborn — automatyczny przeciwnik systemowy.",
          "Agenda — cel albo specjalna możliwość.",
          "Skirmish — uproszczone starcie, odmienne od pełnej Bitwy."
        ]
      }
    ],
    "examples": [],
    "components": [
      {
        "type": "paragraph",
        "text": "Każdy główny zasób ma:"
      },
      {
        "type": "step-list",
        "steps": [
          "wartość produkcji;",
          "aktualny zapas."
        ]
      },
      {
        "type": "paragraph",
        "text": "Płacąc koszt, zmniejszasz zapas, nie produkcję, chyba że efekt mówi wyraźnie inaczej. Produkcja jest aktualizowana przez populację, Gildie, technologie i sektory, a następnie zasila zapas w odpowiedniej fazie."
      },
      {
        "type": "paragraph",
        "text": "Oficjalne FAQ wyjaśnia, że koszty pobiera się ze stockpile widocznego na prawych tarczach zasobów."
      }
    ],
    "scoring": [
      {
        "type": "paragraph",
        "text": "W trybie rywalizacyjnym zdobywasz Wpływ przez rozwój sektorów, realizację Agend, wydarzenia Cykli, walkę i kontrolę. Wygrywa największy wynik po trzecim Cyklu."
      },
      {
        "type": "paragraph",
        "text": "W kooperacji i solo gracze muszą jednocześnie osiągnąć wspólny cel i uniknąć warunków porażki, takich jak nadmierna siła Voidborn, nieopanowane Kryzysy albo niewykonane wymagania scenariusza."
      }
    ]
  },
  "diuna-imperium": {
    "chapters": [
      {
        "title": "1. Cel gry",
        "content": [
          {
            "type": "paragraph",
            "text": "Zdobywaj punkty zwycięstwa przez konflikty, sojusze z frakcjami, karty i efekty. Koniec gry zostaje uruchomiony po zakończeniu rundy, gdy:"
          },
          {
            "type": "step-list",
            "steps": [
              "dowolny gracz ma co najmniej 10 punktów zwycięstwa; albo",
              "wyczerpie się talia Konfliktów."
            ]
          },
          {
            "type": "paragraph",
            "text": "Po kartach Intrygi końca gry i pozostałych efektach wygrywa gracz z największą liczbą punktów."
          }
        ]
      },
      {
        "title": "2. Główne mechanizmy",
        "content": [
          {
            "type": "paragraph",
            "text": "Gra łączy:"
          },
          {
            "type": "step-list",
            "steps": [
              "budowanie talii;",
              "wysyłanie Agentów na pola planszy;",
              "zarządzanie wodą, solari, przyprawą i oddziałami;",
              "tory wpływu czterech frakcji;",
              "konflikt rozstrzygany na końcu rundy;",
              "karty Intrygi."
            ]
          }
        ]
      },
      {
        "title": "3. Przygotowanie",
        "content": [
          {
            "type": "checklist",
            "id": "setup-checklist",
            "title": "Kontrola przygotowania",
            "items": [
              "Przeczytaj kolejność przygotowania przed wyjęciem komponentów.",
              "Wykonaj kroki po kolei i sprawdź konfigurację graczy."
            ]
          },
          {
            "type": "step-list",
            "steps": [
              "Rozłóż planszę.",
              "Przygotuj cztery tory frakcji i znaczniki Sojuszu.",
              "Zbuduj talię Konfliktów odpowiednią do etapów gry.",
              "Przygotuj talię Imperium i odkryj rząd kart.",
              "Przygotuj talie Intrygi.",
              "Umieść zasoby i oddziały w pulach.",
              "Każdy wybiera Lidera, bierze Agents, znacznik punktacji, kostki i talię startową.",
              "Umieść pozycje startowe wpływu i zasobów.",
              "Ustal pierwszego gracza.",
              "W grze dwuosobowej lub solo przygotuj Ród Hagal zgodnie z osobnym trybem."
            ]
          }
        ]
      },
      {
        "title": "4. Anatomia karty",
        "content": [
          {
            "type": "paragraph",
            "text": "Karta może zawierać:"
          },
          {
            "type": "step-list",
            "steps": [
              "ikony Agenta po lewej;",
              "górny efekt używany w turze Agenta;",
              "dolną część Odkrycia;",
              "Perswazję;",
              "Miecze;",
              "frakcję/kategorię;",
              "koszt zakupu;",
              "efekty specjalne."
            ]
          },
          {
            "type": "paragraph",
            "text": "W jednej rundzie karta jest używana albo w turze Agenta, albo później w turze Odkrycia — nie w obu."
          }
        ]
      },
      {
        "title": "5. Struktura rundy",
        "content": [
          {
            "type": "step-list",
            "steps": [
              "Początek rundy.",
              "Tury graczy.",
              "Walka.",
              "Wytwórcy.",
              "Powrót."
            ]
          },
          {
            "type": "heading",
            "text": "Początek rundy",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Odkryj nową kartę Konfliktu i wykonaj efekty początku rundy."
          },
          {
            "type": "heading",
            "text": "Tury graczy",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Gracze naprzemiennie wykonują turę Agenta albo, gdy nie chcą/nie mogą wysłać kolejnego Agenta, turę Odkrycia."
          },
          {
            "type": "paragraph",
            "text": "Po wykonaniu tury Odkrycia gracz nie wykonuje już tur Agenta w tej rundzie."
          }
        ]
      },
      {
        "title": "6. Tura Agenta",
        "content": [
          {
            "type": "step-list",
            "steps": [
              "Wybierz kartę z ręki.",
              "Sprawdź ikonę Agenta i wybierz pasujące, dostępne pole planszy.",
              "Opłać koszt wejścia.",
              "Umieść Agenta.",
              "Rozpatrz efekt pola.",
              "Rozpatrz efekt Agenta z karty.",
              "Wykonaj efekty dodatkowe w dozwolonej kolejności."
            ]
          },
          {
            "type": "paragraph",
            "text": "Karta bez właściwej ikony nie pozwala wejść na pole, nawet jeśli potrafisz opłacić koszt."
          },
          {
            "type": "paragraph",
            "text": "Na polu zajętym przez innego Agenta zwykle nie można postawić kolejnego, chyba że reguła pola lub efekt mówi inaczej."
          }
        ]
      },
      {
        "title": "7. Tura Odkrycia",
        "content": [
          {
            "type": "paragraph",
            "text": "Gdy wykonujesz Odkrycie:"
          },
          {
            "type": "step-list",
            "steps": [
              "odkryj wszystkie pozostałe karty z ręki;",
              "zsumuj Perswazję;",
              "zsumuj Miecze;",
              "rozpatrz efekty Odkrycia;",
              "kup dowolną liczbę kart, opłacając każdą osobno Perswazją;",
              "niewydana Perswazja przepada;",
              "Miecze zwiększają siłę w bieżącym Konflikcie."
            ]
          },
          {
            "type": "paragraph",
            "text": "Kupione karty trafiają zwykle na stos kart odrzuconych, nie do ręki."
          }
        ]
      },
      {
        "title": "8. Budowanie talii",
        "content": [
          {
            "type": "paragraph",
            "text": "Gdy talia dobierania jest pusta, a trzeba dobrać kartę, przetasuj stos odrzuconych i utwórz nową talię."
          },
          {
            "type": "paragraph",
            "text": "Usunięcie karty oznacza trwałe odłożenie jej poza talię. Odrzucenie oznacza przeniesienie na stos odrzuconych."
          },
          {
            "type": "paragraph",
            "text": "Rząd Imperium uzupełnia się zgodnie z zasadami po zakupach."
          }
        ]
      },
      {
        "title": "9. Zasoby",
        "content": [
          {
            "type": "heading",
            "text": "Woda",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Rzadki koszt wejścia na pustynię i niektórych efektów."
          },
          {
            "type": "heading",
            "text": "Solari",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Waluta używana m.in. do pozyskiwania Mistrza Miecza i Radnego Wysokiej Rady."
          },
          {
            "type": "heading",
            "text": "Przyprawa",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Wartościowy zasób zdobywany głównie na pustyni i wydawany na silne pola."
          },
          {
            "type": "paragraph",
            "text": "Zasoby są jawne i nie można wydać więcej, niż się posiada."
          }
        ]
      },
      {
        "title": "10. Oddziały, garnizon i Konflikt",
        "content": [
          {
            "type": "paragraph",
            "text": "Oddziały mogą znajdować się:"
          },
          {
            "type": "step-list",
            "steps": [
              "w zasobach gracza;",
              "w garnizonie;",
              "w Konflikcie;",
              "na planszy jako kontrola, jeżeli efekt to przewiduje."
            ]
          },
          {
            "type": "paragraph",
            "text": "Zdobycie oddziału zwykle umieszcza go w garnizonie. Rozmieszczenie przenosi go z garnizonu do Konfliktu."
          },
          {
            "type": "paragraph",
            "text": "Gdy wchodzisz Agentem na pole z ikoną Konfliktu, możesz rozmieścić dozwoloną liczbę oddziałów zgodnie z regułą pola/akcji."
          }
        ]
      },
      {
        "title": "11. Faza Walki",
        "content": [
          {
            "type": "step-list",
            "steps": [
              "Każdy uczestnik oblicza siłę:",
              "oddziały w Konflikcie;",
              "Miecze z Odkrycia;",
              "efekty Lidera, kart i Intryg.",
              "Gracze mogą zagrywać karty Intrygi Walki w kolejności inicjatywy.",
              "Ustal ostateczną siłę.",
              "Przyznaj nagrody za pierwsze, drugie i trzecie miejsce zgodnie z kartą Konfliktu i liczbą graczy.",
              "Rozstrzygnij remisy według reguły Konfliktu: remisujący gracze otrzymują niższe dostępne nagrody zgodnie z oficjalną procedurą.",
              "Zwróć oddziały z Konfliktu do zasobów, chyba że efekt mówi inaczej.",
              "Umieść znacznik kontroli, jeśli nagroda go przyznaje."
            ]
          },
          {
            "type": "paragraph",
            "text": "Nie doliczaj oddziałów pozostających w garnizonie."
          }
        ]
      },
      {
        "title": "12. Frakcje i wpływ",
        "content": [
          {
            "type": "paragraph",
            "text": "Cztery frakcje:"
          },
          {
            "type": "step-list",
            "steps": [
              "Imperator;",
              "Gildia Kosmiczna;",
              "Bene Gesserit;",
              "Fremeni."
            ]
          },
          {
            "type": "paragraph",
            "text": "Wejście na pola frakcji lub efekty kart podnoszą wpływ."
          },
          {
            "type": "paragraph",
            "text": "Po osiągnięciu wymaganego progu otrzymujesz punkt frakcji. Pierwszy gracz na wysokim progu zdobywa Sojusz. Jeżeli inny gracz później ma więcej wpływu, przejmuje token Sojuszu i punkt związany z tokenem."
          },
          {
            "type": "paragraph",
            "text": "Samo zrównanie się z aktualnym liderem zwykle nie wystarcza do przejęcia Sojuszu."
          }
        ]
      },
      {
        "title": "13. Intrygi",
        "content": [
          {
            "type": "paragraph",
            "text": "Rodzaje:"
          },
          {
            "type": "step-list",
            "steps": [
              "Fabuła — zagrywana w podanym momencie tury;",
              "Walka — podczas Fazy Walki;",
              "Koniec gry — po sygnale końca, przed ustaleniem zwycięzcy."
            ]
          },
          {
            "type": "paragraph",
            "text": "Karty Intrygi są tajne. Nie ujawniaj ich, dopóki ich nie zagrywasz."
          }
        ]
      },
      {
        "title": "14. Wytwórcy",
        "content": [
          {
            "type": "paragraph",
            "text": "W Fazie Wytwórców dodaj Przyprawę na nieodwiedzone pola pustyni z symbolem bonusowej Przyprawy. Jeśli pole nie zostało odwiedzone w kolejnych rundach, bonus kumuluje się."
          },
          {
            "type": "paragraph",
            "text": "Przyprawa na polu trafia do gracza dopiero po wykonaniu odpowiedniej akcji."
          }
        ]
      },
      {
        "title": "15. Powrót",
        "content": [
          {
            "type": "step-list",
            "steps": [
              "zwróć Agentów;",
              "odrzuć zagrane i odkryte karty;",
              "usuń znaczniki rundy;",
              "przekaż znacznik pierwszego gracza;",
              "sprawdź koniec gry."
            ]
          }
        ]
      },
      {
        "title": "16. Rada i Mistrz Miecza",
        "content": [
          {
            "type": "paragraph",
            "text": "Radny Wysokiej Rady zwiększa Perswazję podczas Odkrycia. Mistrz Miecza daje dodatkowego Agenta na przyszłe rundy."
          },
          {
            "type": "paragraph",
            "text": "Koszty i pola muszą być wpisane zgodnie z planszą polskiego wydania."
          }
        ]
      },
      {
        "title": "17. Nieśmiertelność — przygotowanie",
        "content": [
          {
            "type": "paragraph",
            "text": "Dodatek wprowadza:"
          },
          {
            "type": "step-list",
            "steps": [
              "planszę badawczą Tleilaxu;",
              "tor badań;",
              "tor Tleilaxu;",
              "okazy;",
              "karty Tleilaxu;",
              "mechanikę Szczepienia (Graft);",
              "nowe karty Imperium, Intrygi i Liderów."
            ]
          },
          {
            "type": "paragraph",
            "text": "Zastosuj nakładki i zmiany talii zgodnie z oficjalnym setupem. [DO WERYFIKACJI: dokładne karty usuwane/dodawane]."
          }
        ],
        "requiredAddons": [
          "immortality"
        ]
      },
      {
        "title": "18. Okazy",
        "content": [
          {
            "type": "paragraph",
            "text": "Okazy są specjalnym zasobem reprezentowanym zwykle przez oddziały przeniesione do obszaru badawczego. Oddział użyty jako okaz nie jest dostępny w garnizonie ani Konflikcie."
          },
          {
            "type": "paragraph",
            "text": "Okazy wydaje się na pola i efekty Tleilaxu. Po wydaniu trafiają do miejsca wskazanego przez efekt, zwykle do zasobów ogólnych."
          }
        ],
        "requiredAddons": [
          "immortality"
        ]
      },
      {
        "title": "19. Tor badań",
        "content": [
          {
            "type": "paragraph",
            "text": "Ruch na torze badań:"
          },
          {
            "type": "step-list",
            "steps": [
              "daje nagrody z pól;",
              "może rozgałęziać się;",
              "odblokowuje efekty;",
              "prowadzi do korzyści związanych z genetyką i kartami."
            ]
          },
          {
            "type": "paragraph",
            "text": "Wybór odnogi może być trwały. Aplikacja musi pokazać legalne przejścia."
          }
        ],
        "requiredAddons": [
          "immortality"
        ]
      },
      {
        "title": "20. Tor Tleilaxu",
        "content": [
          {
            "type": "paragraph",
            "text": "Tor odzwierciedla postęp w relacji z Bene Tleilax. Progi dają nagrody, punkty albo dostęp do kart. Znacznik przesuwa się tylko przez wyraźne efekty."
          }
        ],
        "requiredAddons": [
          "immortality"
        ]
      },
      {
        "title": "21. Karty Tleilaxu",
        "content": [
          {
            "type": "paragraph",
            "text": "Tworzą oddzielny rząd zakupu. Ich zakup może wymagać okazów, Perswazji albo pozycji na torze. Uzupełniaj wystawkę po zakupie."
          }
        ],
        "requiredAddons": [
          "immortality"
        ]
      },
      {
        "title": "22. Szczepienie",
        "content": [
          {
            "type": "paragraph",
            "text": "Szczepienie pozwala połączyć dwie kompatybilne karty i użyć ich wspólnie w jednej turze:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz kartę z ikoną/zdolnością Szczepienia;",
              "połącz ją z legalną drugą kartą;",
              "traktuj zestaw jako jedną zagrywkę zgodnie z zasadami Agenta lub Odkrycia;",
              "rozpatrz efekty w dozwolonej kolejności;",
              "obie karty trafiają później do właściwej strefy."
            ]
          },
          {
            "type": "paragraph",
            "text": "Nie oznacza to automatycznie dwóch Agentów ani wejścia na dwa pola."
          }
        ],
        "requiredAddons": [
          "immortality"
        ]
      },
      {
        "title": "23. Koniec gry",
        "content": [
          {
            "type": "paragraph",
            "text": "Po zakończeniu rundy uruchamiającej koniec:"
          },
          {
            "type": "step-list",
            "steps": [
              "zagraj karty Intrygi końca gry;",
              "rozpatrz efekty kart i Liderów;",
              "dodaj/odejmij punkty;",
              "ustal największy wynik;",
              "zastosuj oficjalne kryteria remisu."
            ]
          }
        ]
      }
    ],
    "firstGame": [
      {
        "type": "step-list",
        "steps": [
          "graj 3–4 osobowo bez dodatku;",
          "wyjaśnij różnicę między efektem Agenta i Odkrycia;",
          "pokaż garnizon oraz Konflikt osobno;",
          "nie trzymaj Perswazji między rundami;",
          "przed pierwszą Walką policz siłę każdego gracza;",
          "dodatek Nieśmiertelność dołącz po jednej pełnej partii."
        ]
      }
    ],
    "quickReference": [
      {
        "type": "paragraph",
        "text": "Runda: Konflikt → tury Agenta/Odkrycia → Walka → Wytwórcy → Powrót. Agent: karta + ikona + wolne pole + koszt + pole + efekt karty. Odkrycie: Perswazja na zakup, Miecze do Walki. Siła: oddziały w Konflikcie + Miecze + efekty. Koniec: 10 VP lub brak Konfliktów po rundzie."
      }
    ],
    "mistakes": [
      {
        "type": "step-list",
        "steps": [
          "Używanie tej samej karty jako Agenta i w Odkryciu.",
          "Liczenie garnizonu do Walki.",
          "Kupowanie kart za niewydane zasoby zamiast Perswazji.",
          "Przenoszenie nowej karty prosto do ręki.",
          "Przejmowanie Sojuszu przy remisie wpływu.",
          "Wysyłanie dwóch Agentów przez Szczepienie.",
          "Traktowanie okazów jak oddziałów w garnizonie."
        ]
      }
    ],
    "faq": [
      {
        "type": "paragraph",
        "text": "Czy mogę wykonać Odkrycie, mając jeszcze Agenta? Tak. Po Odkryciu nie wysyłasz już Agentów w tej rundzie."
      },
      {
        "type": "paragraph",
        "text": "Czy muszę kupić kartę? Nie."
      },
      {
        "type": "paragraph",
        "text": "Czy niewydana Perswazja przechodzi? Nie."
      },
      {
        "type": "paragraph",
        "text": "Czy Miecze są zasobem? Nie, to siła bieżącego Konfliktu."
      },
      {
        "type": "paragraph",
        "text": "Czy oddział zdobyty podczas Walki dołącza do trwającego Konfliktu? Tylko jeśli efekt wyraźnie mówi o rozmieszczeniu."
      },
      {
        "type": "paragraph",
        "text": "Czy karta Walki może być zagrana po ujawnieniu wszystkich sił? Stosuj okna timingowe i kolejność inicjatywy."
      },
      {
        "type": "paragraph",
        "text": "Czy okaz wraca do garnizonu? Nie automatycznie; wykonaj instrukcję efektu, który go wydaje."
      }
    ],
    "glossary": [
      {
        "type": "step-list",
        "steps": [
          "Agent — pion wysyłany na pole planszy.",
          "Odkrycie — użycie dolnych części pozostałych kart.",
          "Perswazja — siła zakupu kart.",
          "Miecz — siła w bieżącym Konflikcie.",
          "Garnizon — oddziały gotowe do rozmieszczenia.",
          "Konflikt — obszar oddziałów uczestniczących w Walce.",
          "Sojusz — token za najwyższy wpływ we frakcji.",
          "Okaz — zasób dodatku Nieśmiertelność.",
          "Szczepienie — połączenie dwóch kart w jedną zagrywkę."
        ]
      }
    ],
    "examples": [
      {
        "type": "paragraph",
        "text": "Gracz zagrywa kartę z ikoną Bene Gesserit, wysyła Agenta na wolne pole frakcji, opłaca koszt, otrzymuje wpływ i wykonuje efekt karty. W następnej turze wchodzi na pole Konfliktu i rozmieszcza oddziały. Gdy nie ma Agentów, wykonuje Odkrycie, sumuje Perswazję i Miecze, kupuje kartę. W Walce dodaje siłę oddziałów i Miecze, po czym otrzymuje nagrodę. W Fazie Wytwórców pola nieodwiedzone dostają bonusową Przyprawę, a w Fazie Powrotu Agenci wracają."
      }
    ],
    "components": [
      {
        "type": "paragraph",
        "text": "Gra łączy:"
      },
      {
        "type": "step-list",
        "steps": [
          "budowanie talii;",
          "wysyłanie Agentów na pola planszy;",
          "zarządzanie wodą, solari, przyprawą i oddziałami;",
          "tory wpływu czterech frakcji;",
          "konflikt rozstrzygany na końcu rundy;",
          "karty Intrygi."
        ]
      },
      {
        "type": "heading",
        "text": "Woda",
        "level": 1
      },
      {
        "type": "paragraph",
        "text": "Rzadki koszt wejścia na pustynię i niektórych efektów."
      },
      {
        "type": "heading",
        "text": "Solari",
        "level": 1
      },
      {
        "type": "paragraph",
        "text": "Waluta używana m.in. do pozyskiwania Mistrza Miecza i Radnego Wysokiej Rady."
      },
      {
        "type": "heading",
        "text": "Przyprawa",
        "level": 1
      },
      {
        "type": "paragraph",
        "text": "Wartościowy zasób zdobywany głównie na pustyni i wydawany na silne pola."
      },
      {
        "type": "paragraph",
        "text": "Zasoby są jawne i nie można wydać więcej, niż się posiada."
      }
    ],
    "scoring": [
      {
        "type": "paragraph",
        "text": "Zdobywaj punkty zwycięstwa przez konflikty, sojusze z frakcjami, karty i efekty. Koniec gry zostaje uruchomiony po zakończeniu rundy, gdy:"
      },
      {
        "type": "step-list",
        "steps": [
          "dowolny gracz ma co najmniej 10 punktów zwycięstwa; albo",
          "wyczerpie się talia Konfliktów."
        ]
      },
      {
        "type": "paragraph",
        "text": "Po kartach Intrygi końca gry i pozostałych efektach wygrywa gracz z największą liczbą punktów."
      },
      {
        "type": "paragraph",
        "text": "Po zakończeniu rundy uruchamiającej koniec:"
      },
      {
        "type": "step-list",
        "steps": [
          "zagraj karty Intrygi końca gry;",
          "rozpatrz efekty kart i Liderów;",
          "dodaj/odejmij punkty;",
          "ustal największy wynik;",
          "zastosuj oficjalne kryteria remisu."
        ]
      }
    ]
  },
  "nieswiadomy-umysl": {
    "chapters": [
      {
        "title": "1. Cel",
        "content": [
          {
            "type": "paragraph",
            "text": "Gracze są psychoanalitykami rozwijającymi techniki, publikującymi rozprawy i leczącymi pacjentów. Punkty zdobywa się podczas gry i w punktowaniu końcowym. Gdy znacznik reputacji Freuda osiągnie końcowe pole, dokończ bieżącą rundę i rozegraj jeszcze jedną pełną rundę. Następnie wykonaj punktowanie."
          }
        ]
      },
      {
        "title": "2. Najważniejsze systemy",
        "content": [
          {
            "type": "step-list",
            "steps": [
              "stół spotkań i znaczniki Pomysłów;",
              "plansza gracza z kałamarzem i płytkami notatnika;",
              "tarcza Wglądu;",
              "mapa Wiednia z profesorem i Freudem;",
              "karty badań i rozprawy;",
              "pacjenci, warstwy traumy i marzenia;",
              "kawa, puzderka i świetne pomysły;",
              "reputacja;",
              "w Koszmarach: Szaleństwo, spaczone tarcze, koszmarne marzenia, tajemniczy pacjenci, przeobrażone traumy, mroczne Wglądy, pupile i gramofon."
            ]
          }
        ]
      },
      {
        "title": "3. Przygotowanie wspólne",
        "content": [
          {
            "type": "checklist",
            "id": "setup-checklist",
            "title": "Kontrola przygotowania",
            "items": [
              "Przeczytaj kolejność przygotowania przed wyjęciem komponentów.",
              "Wykonaj kroki po kolei i sprawdź konfigurację graczy."
            ]
          },
          {
            "type": "step-list",
            "steps": [
              "Rozłóż planszę miasta i stół spotkań.",
              "Przygotuj stosy dzielnic i umieść znaczniki reputacji na właściwych polach.",
              "Ustaw Freuda na lokacji wskazanej przez losowy cel.",
              "Rozłóż cele lokacji.",
              "Zablokuj pola Pomysłów odpowiednio dla 2 lub 3 graczy.",
              "Przygotuj osobne stosy płytek notatnika poziomu I i II oraz wystawki.",
              "Przygotuj pacjentów typowych i przełomowych.",
              "Na każdego widocznego pacjenta nałóż warstwę traumy.",
              "Przygotuj talie marzeń ukrytych i jawnych oraz wystawkę.",
              "Przygotuj karty badań, rozprawy i pulę świetnych pomysłów."
            ]
          },
          {
            "type": "paragraph",
            "text": "Liczba płytek notatnika:"
          },
          {
            "type": "step-list",
            "steps": [
              "2 graczy: 12 poziomu I i 12 poziomu II;",
              "3 graczy: 15 i 15;",
              "4 graczy: 18 i 18."
            ]
          }
        ]
      },
      {
        "title": "4. Przygotowanie gracza",
        "content": [
          {
            "type": "paragraph",
            "text": "Każdy bierze:"
          },
          {
            "type": "step-list",
            "steps": [
              "planszę gracza i gabinet;",
              "tarczę Wglądu;",
              "profesora;",
              "kałamarz;",
              "znaczniki Pomysłów;",
              "znaczniki terapii;",
              "znaczniki reputacji, punktów, kawy i puzderek;",
              "Wglądy zwykłe i w kolorze gracza;",
              "startową warstwę traumy/pacjenta;",
              "startowe płytki notatnika i zasoby zależne od kolejności."
            ]
          },
          {
            "type": "paragraph",
            "text": "Ustaw elementy zgodnie z oznaczeniami na planszach."
          }
        ]
      },
      {
        "title": "5. Struktura gry",
        "content": [
          {
            "type": "paragraph",
            "text": "Gracze wykonują po jednej turze zgodnie z ruchem wskazówek zegara. W swojej turze wybierz dokładnie jedną opcję:"
          },
          {
            "type": "step-list",
            "steps": [
              "Ogłoś Pomysły.",
              "Przywołaj Pomysły.",
              "Lecz Pacjentów."
            ]
          },
          {
            "type": "paragraph",
            "text": "Po wybranej opcji:"
          },
          {
            "type": "step-list",
            "steps": [
              "możesz użyć puzderek do terapii;",
              "musisz uzupełnić każdy pusty gabinet nowym pacjentem i marzeniami;",
              "usuń świetne Pomysły ze stołu, jeśli wymaga tego ich zasada."
            ]
          }
        ]
      },
      {
        "title": "6. Wglądy",
        "content": [
          {
            "type": "paragraph",
            "text": "Wgląd ma:"
          },
          {
            "type": "step-list",
            "steps": [
              "typ: rozwój, wolność albo pasja;",
              "poziom: mały, średni albo duży."
            ]
          },
          {
            "type": "paragraph",
            "text": "Tarcza ma trzy kolorowe sekcje i trzy okręgi. Centralna rezerwa przechowuje Wglądy bez typu i poziomu."
          },
          {
            "type": "heading",
            "text": "Stworzenie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Przenieś Wgląd z centralnej rezerwy na wskazany poziom i typ."
          },
          {
            "type": "heading",
            "text": "Wzniesienie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Przesuń o jeden okrąg na zewnątrz bez zmiany typu."
          },
          {
            "type": "heading",
            "text": "Stłumienie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Przesuń o jeden okrąg do wewnątrz; z małego poziomu można wrócić do rezerwy."
          },
          {
            "type": "heading",
            "text": "Przesunięcie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Przenieś do sąsiedniej sekcji bez zmiany poziomu."
          },
          {
            "type": "heading",
            "text": "Użycie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Przenieś wymagany Wgląd do centralnej rezerwy. Możesz nadpłacić wyższym poziomem, ale bez reszty."
          },
          {
            "type": "paragraph",
            "text": "Wglądy w kolorze gracza można umieszczać trwale na rozprawach i mapie po ich odblokowaniu."
          }
        ]
      },
      {
        "title": "7. Kawa",
        "content": [
          {
            "type": "paragraph",
            "text": "Kawy można używać w dowolnym momencie własnej tury, także podczas rozpatrywania innego efektu:"
          },
          {
            "type": "step-list",
            "steps": [
              "1 kawa może zastąpić stłumienie Wglądu;",
              "2 kawy pozwalają wznieść albo przesunąć Wgląd;",
              "3 kawy dają świetny Pomysł."
            ]
          },
          {
            "type": "paragraph",
            "text": "Limit kawy wynosi 6. Nadwyżka przepada, ale przed otrzymaniem kawy możesz legalnie wydać posiadaną kawę."
          }
        ]
      },
      {
        "title": "8. Świetne Pomysły",
        "content": [
          {
            "type": "paragraph",
            "text": "Mogą:"
          },
          {
            "type": "step-list",
            "steps": [
              "zastępować Pomysły gracza na stole spotkań;",
              "modyfikować ruch kałamarza;",
              "wzmacniać efekty lokacji;",
              "służyć innym wskazanym efektom."
            ]
          },
          {
            "type": "paragraph",
            "text": "Niewykorzystane świetne Pomysły dają po 1 punkcie na końcu gry. Gdy używasz ich na stole, usuń je w chwili wskazanej przez regułę."
          }
        ]
      },
      {
        "title": "9. Ogłoś Pomysły",
        "content": [
          {
            "type": "paragraph",
            "text": "Wykonaj trzy kroki:"
          },
          {
            "type": "heading",
            "text": "9.1 Umieść Pomysły",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Umieść 1 albo 2 Pomysły na jednym pustym polu stołu spotkań. Skieruj ich ogonki na jedno sąsiednie pole akcji."
          },
          {
            "type": "paragraph",
            "text": "Nie możesz wskazać pola, na które wskazuje już inny twój Pomysł z wcześniejszej tury. Pomysły innych graczy nie blokują pola akcji."
          },
          {
            "type": "paragraph",
            "text": "Świetny Pomysł może zastąpić zwykły Pomysł."
          },
          {
            "type": "heading",
            "text": "9.2 Rozpatrz akcję",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Za każdy umieszczony Pomysł rozpatrz wskazane pole raz. Jeśli wykonałeś akcję dwukrotnie, najpierw zakończ pierwsze rozpatrzenie."
          },
          {
            "type": "paragraph",
            "text": "Pola obejmują m.in.:"
          },
          {
            "type": "step-list",
            "steps": [
              "pozyskiwanie płytek notatnika;",
              "karty badań;",
              "publikowanie;",
              "tworzenie i manipulowanie Wglądami;",
              "ruch profesorów i Freuda;",
              "inne efekty ikon."
            ]
          },
          {
            "type": "heading",
            "text": "9.3 Aktywuj kałamarz",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "Policz symbole kałamarza w rzędzie, w którym umieściłeś Pomysły.",
              "Przesuń kałamarz dokładnie o tę wartość zgodnie z ruchem wskazówek zegara.",
              "Możesz użyć świetnych Pomysłów do legalnej modyfikacji.",
              "Rozpatrz kolumnę albo rząd płytek wskazany przez pole zatrzymania.",
              "Wykonuj efekty w wymaganej kolejności."
            ]
          },
          {
            "type": "paragraph",
            "text": "Nie pomijaj ruchu kałamarza."
          }
        ]
      },
      {
        "title": "10. Płytki notatnika",
        "content": [
          {
            "type": "paragraph",
            "text": "Płytki mają akcję główną i baner. Zdobywając płytkę:"
          },
          {
            "type": "step-list",
            "steps": [
              "zapłać wymagany koszt kawy lub efektu;",
              "umieść w legalnym pustym miejscu;",
              "rozpatrz stronę/efekt zgodnie z ikoną;",
              "uzupełnij wystawkę."
            ]
          },
          {
            "type": "paragraph",
            "text": "Rzędy i kolumny tworzą silnik uruchamiany kałamarzem. Wypełnione rzędy punktują na końcu."
          }
        ]
      },
      {
        "title": "11. Karty badań i rozprawy",
        "content": [
          {
            "type": "heading",
            "text": "Zdobywanie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Dobierz kartę z wystawki lub talii zgodnie z akcją."
          },
          {
            "type": "heading",
            "text": "Zagrywanie",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Zagraj dozwoloną liczbę kart i rozpatrz ich symbole lokacji/efekty."
          },
          {
            "type": "heading",
            "text": "Publikacja",
            "level": 1
          },
          {
            "type": "step-list",
            "steps": [
              "Wybierz dostępną rozprawę.",
              "Pierwszy wymagany tom musi pochodzić z własnej karty badań w grze.",
              "Pozostałe tomy mogą pochodzić z własnych kart albo z cytowania rozpraw innych graczy.",
              "Nie cytuj własnej rozprawy.",
              "Przy cytowaniu zacznij od prawej strony i nie zostawiaj przerw.",
              "Autor cytowanej rozprawy otrzymuje 2 punkty i świetny Pomysł za każdy cytowany tom.",
              "Umieść własny odblokowany Wgląd w kolorze gracza na rozprawie.",
              "Zdobądź punkty rozprawy."
            ]
          }
        ]
      },
      {
        "title": "12. Mapa miasta",
        "content": [
          {
            "type": "paragraph",
            "text": "Mapa ma 3 dzielnice, każda po 2 lokacje. Lokacje:"
          },
          {
            "type": "step-list",
            "steps": [
              "Teatr;",
              "Biblioteka;",
              "Opera;",
              "Muzeum;",
              "Uniwersytet;",
              "Kawiarnia."
            ]
          },
          {
            "type": "paragraph",
            "text": "Ruch profesora albo Freuda odbywa się zgodnie z ruchem wskazówek zegara, chyba że efekt mówi inaczej."
          },
          {
            "type": "paragraph",
            "text": "Po wejściu do lokacji rozpatrz jej efekt do liczby wynikającej z:"
          },
          {
            "type": "step-list",
            "steps": [
              "liczby figurek na polu; albo",
              "liczby właściwych symboli lokacji posiadanych w grze;"
            ]
          },
          {
            "type": "paragraph",
            "text": "zależnie od wybranej metody i limitu."
          },
          {
            "type": "paragraph",
            "text": "Świetne Pomysły mogą zwiększyć liczbę rozpatrzeń, ale nie ponad limit."
          }
        ]
      },
      {
        "title": "13. Przywołaj Pomysły",
        "content": [
          {
            "type": "paragraph",
            "text": "Ta opcja odzyskuje Pomysły ze stołu i aktywuje premie mapy:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz grupę własnych Pomysłów do przywołania zgodnie z zasadą;",
              "przenieś je do puli;",
              "rozpatrz premię dzielnicy/lokacji powiązaną z profesorem;",
              "umieść odblokowany Wgląd w kolorze gracza, jeśli płacisz wymagany koszt;",
              "wykonaj efekty przywołania i aktualizuj mapę."
            ]
          },
          {
            "type": "paragraph",
            "text": "[DO WERYFIKACJI: dokładna kolejność i wszystkie premie pól mapy w katalogu ikon]."
          }
        ]
      },
      {
        "title": "14. Lecz Pacjentów",
        "content": [
          {
            "type": "paragraph",
            "text": "Wybierz marzenie i pacjenta:"
          },
          {
            "type": "step-list",
            "steps": [
              "użyj Wglądów i ewentualnie kawy wymaganych przez marzenie;",
              "stwórz wskazaną liczbę punktów terapii;",
              "przesuwaj znacznik terapii pacjenta w lewo;",
              "rozpatruj każde mijane pole;",
              "gdy przekroczysz Katharsis, zdobądź wskazane punkty, usuń warstwę traumy i aktywuj stałą część pacjenta;",
              "gdy dojdziesz do końca, pacjent jest wyleczony i daje punkty;",
              "odrzuć wykorzystane marzenie."
            ]
          },
          {
            "type": "paragraph",
            "text": "Musisz wykorzystać maksymalną możliwą liczbę punktów terapii na pacjenta. Dopiero nadmiar po wyleczeniu zamienia się w puzderka zgodnie z regułą."
          },
          {
            "type": "paragraph",
            "text": "Pasujący symbol snu i traumy może dać dodatkowe puzderko."
          }
        ]
      },
      {
        "title": "15. Puzderka",
        "content": [
          {
            "type": "paragraph",
            "text": "Na końcu tury możesz wydawać puzderka po jednym, aby tworzyć punkty terapii dla dowolnych swoich pacjentów. Każdy punkt rozpatruj osobno."
          },
          {
            "type": "paragraph",
            "text": "W dowolnym momencie możesz też użyć zestawu małego, średniego i dużego Wglądu dowolnych typów, aby otrzymać puzderko."
          }
        ]
      },
      {
        "title": "16. Nowy pacjent",
        "content": [
          {
            "type": "paragraph",
            "text": "Dla każdego pustego gabinetu:"
          },
          {
            "type": "step-list",
            "steps": [
              "wybierz widocznego pacjenta;",
              "uzupełnij wystawkę i dodaj nową warstwę traumy;",
              "dobierz ukryte marzenie;",
              "wybierz jawne marzenie z wystawki albo talii;",
              "ustaw znacznik terapii na sumie wymaganej przez pacjenta i traumę;",
              "zdobądź punkty startowego pola, jeśli je ma."
            ]
          },
          {
            "type": "paragraph",
            "text": "Drugi gabinet odblokowujesz przez Katharsis pacjenta startowego."
          }
        ]
      },
      {
        "title": "17. Cele lokacji",
        "content": [
          {
            "type": "paragraph",
            "text": "Gdy po raz pierwszy spełnisz warunek dostępnego celu:"
          },
          {
            "type": "step-list",
            "steps": [
              "natychmiast go zdobądź;",
              "zyskaj punkt reputacji;",
              "odłóż kafel zakryty do swojej strefy;",
              "zachowaj jego symbole lokacji do końca gry."
            ]
          },
          {
            "type": "paragraph",
            "text": "Przykładowe warunki:"
          },
          {
            "type": "step-list",
            "steps": [
              "dwa wypełnione rzędy/kolumny;",
              "odblokowane Pomysły;",
              "opublikowane rozprawy;",
              "Wglądy na mapie;",
              "określona liczba wyleczonych pacjentów."
            ]
          }
        ]
      },
      {
        "title": "18. Reputacja",
        "content": [
          {
            "type": "paragraph",
            "text": "Gdy zdobywasz reputację:"
          },
          {
            "type": "step-list",
            "steps": [
              "przesuń Freuda;",
              "przesuń własny znacznik;",
              "zastosuj pola i sygnał końca."
            ]
          },
          {
            "type": "paragraph",
            "text": "Rozpatrzenie toru reputacji daje punkty/kawę i wybraną akcję z obszaru, ale samo nie przesuwa znaczników."
          },
          {
            "type": "paragraph",
            "text": "Gdy Freud osiąga pole końca:"
          },
          {
            "type": "step-list",
            "steps": [
              "aktywny gracz dostaje wskazane punkty;",
              "odwróć znacznik pierwszego gracza;",
              "dokończ rundę;",
              "rozegraj jeszcze jedną rundę;",
              "przejdź do punktowania."
            ]
          }
        ]
      },
      {
        "title": "19. Koszmary — przygotowanie",
        "content": [
          {
            "type": "step-list",
            "steps": [
              "dodaj tajemniczych pacjentów do odpowiednich połówek talii;",
              "dodaj koszmarne marzenia i osobną wystawkę;",
              "wmieszaj przeobrażone warstwy traumy do części talii;",
              "dodaj uniwersalne karty badań;",
              "rozłóż rozprawę o zmarłych;",
              "dodaj cel nawiedzonej lokacji;",
              "przygotuj żetony Szaleństwa i mroczne Wglądy;",
              "użyj spaczonych tarcz;",
              "rozdaj szalone startowe płytki notatnika;",
              "ustaw żeton sprawdzenia Szaleństwa na właściwym polu reputacji."
            ]
          }
        ],
        "requiredAddons": [
          "nightmares"
        ]
      },
      {
        "title": "20. Szaleństwo",
        "content": [
          {
            "type": "paragraph",
            "text": "Gdy otrzymujesz Szaleństwo, weź żeton. Pula jest nieograniczona."
          },
          {
            "type": "paragraph",
            "text": "Poziomy odblokowują korzystne efekty:"
          },
          {
            "type": "step-list",
            "steps": [
              "od 3: ruch profesora może odbywać się przeciwnie do wskazówek;",
              "od 5: dwa Pomysły mogą wskazywać dwa różne pola;",
              "od 8: dodatkowa elastyczność średnich Wglądów;",
              "od 13: przy przywołaniu zwróć 6 Szaleństwa."
            ]
          },
          {
            "type": "paragraph",
            "text": "Stosuj dokładny tekst karty podsumowania."
          },
          {
            "type": "heading",
            "text": "Sprawdzenie Szaleństwa",
            "level": 1
          },
          {
            "type": "paragraph",
            "text": "Uruchamia się:"
          },
          {
            "type": "step-list",
            "steps": [
              "po przekroczeniu właściwego pola przez Freuda;",
              "gdy pierwszy gracz osiągnie co najmniej 13 i zdobędzie nawiedzony cel;",
              "przed punktacją końcową."
            ]
          },
          {
            "type": "paragraph",
            "text": "Procedura:"
          },
          {
            "type": "step-list",
            "steps": [
              "znajdź najniższy poziom Szaleństwa;",
              "wszyscy usuwają tyle Szaleństwa;",
              "każdy traci punkty równe pozostałemu Szaleństwu;",
              "w szalonym wariancie kara jest podwojona."
            ]
          }
        ],
        "requiredAddons": [
          "nightmares"
        ]
      },
      {
        "title": "21. Spaczona tarcza i szalone Wglądy",
        "content": [
          {
            "type": "paragraph",
            "text": "Każdy typ ma małe, średnie i duże spaczenie:"
          },
          {
            "type": "step-list",
            "steps": [
              "małe: pojemność 1, bez Szaleństwa;",
              "średnie: pojemność 2, +1 Szaleństwa;",
              "duże: pojemność 3, +2 Szaleństwa."
            ]
          },
          {
            "type": "paragraph",
            "text": "Wgląd w spaczeniu jest szalony. Nie można go standardowo wznieść, stłumić ani przesunąć. Po użyciu wraca do centralnej rezerwy."
          },
          {
            "type": "paragraph",
            "text": "Szalony Wgląd może nadpłacić dowolny poziom tego samego typu."
          }
        ],
        "requiredAddons": [
          "nightmares"
        ]
      },
      {
        "title": "22. Mroczne Wglądy",
        "content": [
          {
            "type": "paragraph",
            "text": "Działają jak zwykłe, ale umieszczenie ich w spaczeniu nie daje Szaleństwa. Zdobywa się je głównie przez Katharsis tajemniczych pacjentów."
          }
        ],
        "requiredAddons": [
          "nightmares"
        ]
      },
      {
        "title": "23. Koszmarne marzenia",
        "content": [
          {
            "type": "paragraph",
            "text": "Koszmarne marzenie wymaga co najmniej jednego szalonego Wglądu. Tworzy punkt terapii Katharsis:"
          },
          {
            "type": "step-list",
            "steps": [
              "jeśli znacznik jest za polem Katharsis, przesuń go bezpośrednio do Katharsis i rozpatrz je;",
              "w innym wypadku użyj punktu jak zwykłej terapii."
            ]
          }
        ],
        "requiredAddons": [
          "nightmares"
        ]
      },
      {
        "title": "24. Tajemniczy pacjenci i przeobrażone traumy",
        "content": [
          {
            "type": "paragraph",
            "text": "Tajemniczy pacjenci dają specjalne efekty Katharsis i punktowanie. Przeobrażona trauma kieruje pacjenta ku Koszmarom. Teksty indywidualne muszą być w katalogu kart."
          }
        ],
        "requiredAddons": [
          "nightmares"
        ]
      },
      {
        "title": "25. Pupile",
        "content": [
          {
            "type": "paragraph",
            "text": "Moduł można stosować z podstawą albo Koszmarami."
          },
          {
            "type": "step-list",
            "steps": [
              "pupil ma tor czterech poziomów;",
              "podczas ustalania ruchu kałamarza możesz przekazać pupilowi 1–2 punkty ruchu;",
              "kałamarz musi poruszyć się co najmniej o 1;",
              "po wejściu pupila na pole wykonaj efekt;",
              "strona kafla zależy od użycia Koszmarów;",
              "Id w solo nie używa pupila."
            ]
          }
        ],
        "requiredAddons": [
          "nightmares"
        ]
      },
      {
        "title": "26. Gramofon",
        "content": [
          {
            "type": "paragraph",
            "text": "Gramofon jest osobnym modułem zmieniającym wybraną lokalizację i sposób korzystania z efektów. [DO WERYFIKACJI: pełna sekwencja modułu z polskiej instrukcji dodatku]."
          }
        ],
        "requiredAddons": [
          "nightmares"
        ]
      },
      {
        "title": "27. Punktowanie końcowe",
        "content": [
          {
            "type": "paragraph",
            "text": "Po ostatniej rundzie:"
          },
          {
            "type": "step-list",
            "steps": [
              "przy Koszmarach wykonaj ostatnie sprawdzenie Szaleństwa;",
              "zdobądź punkty z pola reputacji;",
              "przyznaj premie za pierwsze i drugie miejsce reputacji: opublikowane rozprawy i wyleczeni pacjenci;",
              "punktuj Wglądy w kolorze gracza w różnych dzielnicach;",
              "punktuj wypełnione rzędy notatnika;",
              "punktuj różne symbole lokacji;",
              "punktuj pacjentów przełomowych i tajemniczych;",
              "punktuj świetne Pomysły;",
              "dodaj wszystkie efekty końcowe;",
              "rozstrzygnij remis."
            ]
          },
          {
            "type": "paragraph",
            "text": "[DO WERYFIKACJI: pełna tabela końcowa i kryterium remisu]."
          }
        ]
      }
    ],
    "firstGame": [
      {
        "type": "step-list",
        "steps": [
          "Graj bez modułów i bez Koszmarów.",
          "Pokaż trzy opcje tury.",
          "W pierwszej turze każdy Ogłasza Pomysły.",
          "Fizycznie przesuń kałamarz i uruchom wskazaną linię.",
          "Następnie pokaż Przywołanie.",
          "Leczenie omów na jednym pacjencie z jawnie policzonymi Wglądami.",
          "Koszmary dodaj dopiero po zrozumieniu terapii i tarczy Wglądu."
        ]
      }
    ],
    "quickReference": [
      {
        "type": "paragraph",
        "text": "Tura: Ogłoś / Przywołaj / Lecz → opcjonalne puzderka → obowiązkowe uzupełnienie gabinetów. Ogłoś: umieść 1–2 Pomysły → akcja → kałamarz. Wgląd: stwórz / wznieś / stłum / przesuń / użyj. Terapia: zapłać marzenie → punkty terapii → Katharsis → wyleczenie. Koniec: Freud na końcu → dokończ rundę → jeszcze jedna runda → scoring."
      }
    ],
    "mistakes": [
      {
        "type": "step-list",
        "steps": [
          "Pomijanie obowiązkowego ruchu kałamarza.",
          "Umieszczanie Pomysłów na dwóch polach w podstawowej grze.",
          "Kierowanie nowego Pomysłu na pole już wskazane przez własny Pomysł.",
          "Używanie karty badań z ręki do publikacji.",
          "Cytowanie własnej rozprawy.",
          "Zatrzymywanie niewykorzystanych punktów terapii.",
          "Zdobywanie punktów pacjenta przy Katharsis zamiast przy wyleczeniu.",
          "Traktowanie puzderka jak punktu terapii przed wydaniem.",
          "Poruszanie szalonego Wglądu standardowymi efektami.",
          "Pomijanie końcowego sprawdzenia Szaleństwa."
        ]
      }
    ],
    "faq": [
      {
        "type": "paragraph",
        "text": "Czy mogę wykonać dwie opcje tury? Nie."
      },
      {
        "type": "paragraph",
        "text": "Czy dwa Pomysły muszą wskazywać to samo pole? W podstawowej grze tak. Koszmary mogą odblokować wyjątek przy odpowiednim poziomie Szaleństwa."
      },
      {
        "type": "paragraph",
        "text": "Czy kawa może być wydana w trakcie efektu? Tak, w dowolnym momencie własnej tury."
      },
      {
        "type": "paragraph",
        "text": "Czy wyższy Wgląd może zastąpić niższy? Tak, bez reszty."
      },
      {
        "type": "paragraph",
        "text": "Czy mogę dobrowolnie nie wykorzystać części terapii? Nie. Musisz wykorzystać maksymalną możliwą liczbę punktów."
      },
      {
        "type": "paragraph",
        "text": "Kiedy dobieram pacjenta? Na końcu własnej tury, jeśli gabinet jest pusty."
      },
      {
        "type": "paragraph",
        "text": "Czy Freud uruchamia efekty lokacji przy ruchu na torze reputacji? Nie, jeśli jest przesuwany tylko przez przekroczenie symbolu na torze."
      },
      {
        "type": "paragraph",
        "text": "Czy Szaleństwo jest wyłącznie karą? Nie. Odblokowuje stałe korzyści, ale powoduje straty w sprawdzeniach."
      }
    ],
    "glossary": [
      {
        "type": "step-list",
        "steps": [
          "Pomysł — znacznik pracownika na stole spotkań.",
          "Kałamarz — znacznik aktywujący rząd lub kolumnę silnika.",
          "Wgląd — zasób o typie i poziomie.",
          "Katharsis — punkt terapii usuwający traumę i aktywujący pełny tekst pacjenta.",
          "Puzderko — zasób zamieniany na punkt terapii.",
          "Świetny Pomysł — uniwersalny znacznik i modyfikator.",
          "Rozprawa — publikacja tworzona z tomów badań.",
          "Szaleństwo — zasób/ryzyko dodatku Koszmary.",
          "Spaczenie — miejsce przechowywania szalonego Wglądu."
        ]
      }
    ],
    "examples": [],
    "components": [
      {
        "type": "step-list",
        "steps": [
          "stół spotkań i znaczniki Pomysłów;",
          "plansza gracza z kałamarzem i płytkami notatnika;",
          "tarcza Wglądu;",
          "mapa Wiednia z profesorem i Freudem;",
          "karty badań i rozprawy;",
          "pacjenci, warstwy traumy i marzenia;",
          "kawa, puzderka i świetne pomysły;",
          "reputacja;",
          "w Koszmarach: Szaleństwo, spaczone tarcze, koszmarne marzenia, tajemniczy pacjenci, przeobrażone traumy, mroczne Wglądy, pupile i gramofon."
        ]
      }
    ],
    "scoring": [
      {
        "type": "paragraph",
        "text": "Gracze są psychoanalitykami rozwijającymi techniki, publikującymi rozprawy i leczącymi pacjentów. Punkty zdobywa się podczas gry i w punktowaniu końcowym. Gdy znacznik reputacji Freuda osiągnie końcowe pole, dokończ bieżącą rundę i rozegraj jeszcze jedną pełną rundę. Następnie wykonaj punktowanie."
      },
      {
        "type": "paragraph",
        "text": "Po ostatniej rundzie:"
      },
      {
        "type": "step-list",
        "steps": [
          "przy Koszmarach wykonaj ostatnie sprawdzenie Szaleństwa;",
          "zdobądź punkty z pola reputacji;",
          "przyznaj premie za pierwsze i drugie miejsce reputacji: opublikowane rozprawy i wyleczeni pacjenci;",
          "punktuj Wglądy w kolorze gracza w różnych dzielnicach;",
          "punktuj wypełnione rzędy notatnika;",
          "punktuj różne symbole lokacji;",
          "punktuj pacjentów przełomowych i tajemniczych;",
          "punktuj świetne Pomysły;",
          "dodaj wszystkie efekty końcowe;",
          "rozstrzygnij remis."
        ]
      },
      {
        "type": "paragraph",
        "text": "[DO WERYFIKACJI: pełna tabela końcowa i kryterium remisu]."
      }
    ]
  }
};

function withConsolidatedAddons(
  book: PerfectRulebook,
  addonId: string,
  hubTitle: string
): PerfectRulebook {
  return {
    ...book,
    chapters: consolidateAddonChapters(book.chapters, addonId, hubTitle),
  };
}

export const perfectRulebooks: Record<string, PerfectRulebook> = {
  ...rawPerfectRulebooks,
  'diuna-imperium': withConsolidatedAddons(
    rawPerfectRulebooks['diuna-imperium'],
    'immortality',
    'Nieśmiertelność'
  ),
  'nieswiadomy-umysl': withConsolidatedAddons(
    rawPerfectRulebooks['nieswiadomy-umysl'],
    'nightmares',
    'Koszmary'
  ),
};
